module.exports = {
  PleaseChooseJob: 'SelectBookingNote.',
  NoSearchingInfo: 'No searching information.',
  NoRecordMeetTheConditions: 'No record meet the conditions.',
  Error: 'ErrorOccured.',
  Locked: 'Locked',
  UnKnownStatus: 'UnKnown Status',
  CloseDetailWindow: 'Close detail window',
  AdvancedSearch: 'SeniorSearch',
  NoCustomersFoundPleaseRefreshCache: 'No customers found,Please refresh cache!',
  SelectedMonthHasBeenClosed: 'The currently selected month has been closed.',
  AccountClosedSuccessfully: 'Account closed successfully.',
  PleaseSelectClosingRecord: 'Please select closing record.',
  ClosingRecordHasBeenApproved: 'The closing record has been approved and cannot be cancelled.',
  CancelTheClosingRecord: 'Are you sure you want to cancel the closing record?',
  AccountClosingRecordCanceled: 'Account closing record canceled',
  CannotBeCancelledAfterApproval: 'The closing record cannot be cancelled after approval, are you sure?',
  ClosingDateAfterCancelingTheApproval: 'You can cancel the closing date after canceling the approval, are you sure?',
  BillingType: 'Billing Type',
  ByTicket: 'By Ticket',
  InvitationListTip: 'The customer has submitted the feed, and inviting the pair again will unlock the customer\'s feed page and allow the edit to submit again! Do you want to continue?',
  PleaseClickFirst: 'Please click "Confirm order" first.',
  PleaseSelectTheFeeYouNeedToPush: 'Please select the fee you need to push',
  PleaseSelectTheFeeYouNeedToCopy: 'Please select the fee you need to copy',
  PleaseSeparateMultipleEmailAddressesWithCommas: 'Please separate multiple email addresses with commas',
  PleaseSupplementOtherMailboxes: 'Please supplement other mailboxes',
  ContactAndEmailAreNotMaintained: 'Contact and email are not maintained',
  PleaseSelectTheMaintainedContactAndMailbox: 'Contact and email are not maintained',
  SelectMailbox: 'Select Mailbox',
  InvoiceUuidCannotBeBlank: 'Invoice uuid cannot be blank',
  lackInvoiceConfirm: 'There is no file marked as invoice for this payment request. Do you want to submit anyway?',
  TheSettlementUnitIDCannotBeEmpty: 'The settlement unit ID cannot be empty!',
  PleaseEnterYourEmailAddress: 'Please enter your email address',
  Monthly: 'MonthlySettlement',
  PleaseSelectTheDataYouWantToExport: 'Please select the data you want to export',
  NoData: 'No Data',
  PleaseSelectJob: 'Please select job.',
  ThisJobIsNotWorkingCanNotBeEdited: 'This job not operating, can not edit',
  CanNotEditJob: 'can not edit {0} This job！',
  TheSameSalesAndOperationsConfirmThatYouWantToSave: 'The same sales and operations, confirm that you want to save?',
  SolicitationTypeIsNotTheSameAsSubBillDoYouWantToSaveIt: 'BizSourceNotSameAsBillSaveStill?',
  WHNoRepeatedContinue: 'WarehouseInNoDuplicatedContinueStill?',
  Prompt: 'Prompt',
  MblNoRepeatedContinue: 'MB/LNoDuplicatedContinueStill?',
  MblNoRepeatedNotCurrentCompanyContinue: 'The tracking number you entered does not belong to the operating branch or department of the current business. Please confirm whether to continue',
  MblNoRepeatedNotCurrentCompanyContinueAll: 'The MBL you entered is duplicated and does not belong to the operating branch or department of the current business. Please confirm if you want to continue',
  MblNoSiRepeatedContinue: 'MB/LNoDuplicatedContinueStill?',
  MblNoRepeatedNotSave: 'MB / L No.[{0}] duplicate. Saving is not allowed.',
  AlreadyAssociatedWithOtherBranches: 'There are already [{0}] associated with other branches. Please select another partner to associate!',
  CustomerRefNoRepeatedContinue: 'MB/LNoDuplicatedContinueStill?',
  HblNoRepeatedContinue: 'HB/LNoDuplicatedContinueStill?',
  SoNoRepeatedContinue: 'SoNo repeated, continue?',
  HAWBRepeatedContinue: 'HAWBNoDuplicatedNotAllowed',
  HBLRepeatedContinue: 'HBL no duplicated not allowed',
  IATACodeRepeat: 'IATA CODE cannot be duplicated',
  AirCodeRepeat: 'Airlines cannot be duplicated',
  AuthenticationFailed: 'VerifyFailed!',
  SaveSuccessfully: 'Save successfully',
  InvoiceNoLength: 'The invoice number is too long, please check',
  Success: 'Success',
  ShutOutSuccessfully: 'Shut out successfully',
  CancellationSuccessfully: 'Cancellation successfully',
  CancelShutOutSuccessfully: 'Cancel shut out successfully',
  ThisTemplateCouldNotBeResolvedPleaseContactCS: 'This template could not be resolved, Please contact customer service.',
  CurrentBranchIsNotSelectedCannotAddNewBookings: 'Current branch is not selected, Cannot add new bookings.',
  CompanySelectedIsHQCannotAddNewBookings: 'Company selected is HQ, Cannot add new bookings.',
  TheLastOfTheNewStateHasBeenRestored: 'LastOfTheNewStatusRestored.',
  CancelMotify: 'CancelCurrentModification?',
  Info: 'Information',
  NoBusinessCanBeSplit: 'No business can be split.',
  SplittingErrorContainerInformationIsEmpty: 'SplitingErrorContainerVanninginformationEmpty.',
  IsNotOperationStatus: 'is not operation status.',
  SureDelete: 'Sure delete?',
  DeleteSuccessfully: 'Delete successfully',
  CustomerIssuing: 'If you have not checked the HBL customer self issuing order, please go to the HBL tab to check',
  CustomerIssuingTips: 'Release status: To be collected/deducted. Continue to upload the file type "Customer Self issued Doc"?',
  DirectBusiness: 'MasterB/L',
  SplittingBusiness: 'HouseB/L',
  NoPermissionToEditTheJob: 'No permission to edit the job.',
  HaveBusinessHasBeenSubmittedCannotBeShutOut: 'SelectedRecordsInclFinancialReviewingCheckPlease.',
  HaveBusinessHasBeenShutOuted: 'SelectedRecordsInclShutOutOnesCheckPlease.',
  HaveBusinessHasBeenCancellation: 'The selected record contains invalid services. Please check.',
  PleaseRemoveThisTicketFromMblThenShutOutBatch: 'RemoveSelectedShptFromMasterShptAndShutOut.',
  PleaseRemoveAllTicketsFromMblThenShutOutBatch: 'RemoveAllShptsFromSelectedMasterShptAndShutOut.',
  HasChargeToShutOutTip: 'The business with fees will be closed with fees. Is it confirmed?',
  NoneChargeToShutOutTip: 'Are you sure that the no-cost business will be checked out without cost?',
  BusinessHasBeenSubmittedCannotBeShutOut: 'Business has been submitted, cannot be shut out.',
  NoPermissionToCancelTheShutOut: 'No permission to cancel the shut out.',
  ConfirmToCancelTheShutOut: 'Confirm cancel the shut out?',
  Warning: 'Warning',
  NoChargeToShutOut: 'ShutOutWithoutExpense',
  HasChargeToShutOut: 'ShutOutWithExpense',
  PleaseConfirmTheShutOut: 'Please confirm the shut out?',
  SendStatusChangeNotification: 'Send status change notification',
  StatusChangeNotification: 'Status change notification(Insiders)',
  OptionIsChecked: 'If this option is checked, the internal and external SOP change notification email will be triggered',
  OnlyBeUsedForChangingCosts: 'AdjustRelatedExpenseOnly',
  DoNotMakeAnyChanges: 'NoAdjust(OrAllExpensesDeleted)',
  IfDoNotClearTheConfirmationFeeDoNotAllowFreeShutOut: 'NoRemoveConfirmedExpenseShutOutWithCharge',
  PleaseRemoveThisTicketFromMblThenShutOut: 'Please remove this ticket from MBL,then shut out',
  PleaseRemoveAllTicketsFromMblThenShutOut: 'Please remove all tickets from MBL,then shut out',
  TicketsMustBeVoted: 'AllHouseShptsMustAddIntoMasterShpt',
  NotAllFeesAndChargesPayableAuditCannotBeSubmittedInAdvance: 'Not all fees and charges payable Audit cannot be submitted in advance.',
  CommitSuccessfully: 'SubmitSuccessfully.',
  LCLTicketCannotBeSubmittedSeparatelyPleaseSubmitTheMBL: 'LCLShptsNotSubmitSeparatelySubmitMasterShpt.',
  GenerateExpensesBasedOnCurrentSellingPriceAndBuyingPrice: 'Generate expense based on current selling price and buying price?',
  PlatformCodeNotFound: 'No air freight with platform code A/F found in the charging item',
  Withdraw: 'Withdraw',
  AlreadyReturn: 'Return.',
  AlreadyWithdraw: 'Withdrawn.',
  ReturnAction: 'ReturnToOperation',
  IsConfirm: 'ConfirmOrNot',
  Return: 'Return',
  BatchReturnSucceeded: 'Batch return succeeded:{0}',
  BatchReturnPreSubmitCheck: 'Only pre submitted docs can be returned.',
  BatchReturnSubmitCheck: 'Only docs in submitted status can be withdrawn.',
  BusinessIsNotCommittedAndCannotBeWithdrawn: 'The business is not committed and cannot be withdrawn.',
  BusinessIsNotPreCommittedAndCannotBeReturn: 'The business is not pre-committed and cannot be return.',
  BatchUnlockLockedBillsOfAccountsReceivable: 'You can only batch unlock the locked bills of accounts receivable!',
  lowBalanceTips: 'You have insufficient balance to recognize all the batch-uploaded customs declaration documents.<br/>You can choose to continue uploading files to the file history, but in this case, the system will not recognize the customs declaration information. This means that the files you upload will be saved but will not be analyzed for customs declaration information.<br/> If you choose to upload after recharge, the system will default to not uploading files and not parsing the customs declarations.',
  lowBalanceTips1: 'Continue to upload files',
  lowBalanceTips2: 'Upload after recharge',
  BatchUnlockLockingBillsOfAccountsReceivable: 'You can only batch locking the unlocked bills of accounts receivable!',
  BatchUnlockLockingBillsOfAccountsPayable: 'You can only batch locking the unlocked bills of payable fees!',
  BatchUnlockLockedBillsOfAccountsPayable: 'You can only batch unlock the locked bills of payable fees!',
  UnlockChargeStatus: 'Are you sure to unlock {0} expense status?',
  LockingChargeStatus: 'Are you sure to locking {0} expense status?',
  SuccessfullyUnlockedFeesInBatch: 'Batch unlock {0} fee succeeded: {1}',
  SuccessfullylockingedFeesInBatch: 'Batch locking {0} fee succeeded: {1}',
  ThereAreFeesReceivableNotInvoicedPrint: 'There are fees receivable not invoiced, print?',
  ThereAreFeesReceivableNotInvoicedSubmit: 'There are fees receivable not invoiced, submit?',
  VerifyThatTheRelatedFileHasBeenUploadedBeforeSubmittingSystemContinue: 'This form will be submitted to the financial audit, verify that the related file has been uploaded before submitting system, continue?',
  SubmittedToTheSuperiorAuditVerifyThatTheRelatedFileHasBeenUploadedBeforeSubmittingSystemContinue: 'This single business will be submitted to the superior audit, verify that the related file has been uploaded before submitting system, continue?',
  PleaseInputTheSalesInformationAndPrints: 'Please input the sales information and prints!',
  PleaseInputTheSalesInformationAndSubmit: 'Please input the sales information and submit!',
  FollowingTheSingleDidNotEnterTheSalesInformation: 'FollowsWithoutSalesPersonInformation',
  PleaseEnterAndPrint: 'Please enter and print!',
  PleaseSelectAWaterBillRecord: 'Please select a water bill record',
  PleaseEnterAndSubmit: 'Please enter and submit!',
  WithCostsAbroadWithoutValidBillingNumberYouCannotPrintAnAnalysisOfProfitTable: 'With costs abroad without valid billing number, you cannot print an analysis of profit table!',
  WithCostsAbroadWithoutValidBillingNumberCannotBeSubmitted: 'With costs abroad without valid billing number, cannot be submitted!',
  BulkSubmissionOfWrittenSubmissionsOnlyList: 'BatchSubmissionOfPresubmissionDOCOnly!',
  BulkSubmissionOfWrittenPreSubmissionsOnlyList: 'BatchSubmissionOfOperatingDOCOnly!',
  MakeSureToSubmitAListOftheNFinancialAuditPlease1: 'Make sure to submit a list of the',
  MakeSureToSubmitAListOftheNFinancialAuditPlease12: 'MakeSureThisShptForFinancialAudit?',
  BatchSubmittedSuccessfully: 'Batch submitted successfully',
  BatchSubmittedPreSuccessfully: 'BatchPresubmissonSuccessfully',
  TheSelectedDocumentInconsistentNatureOfTheBooking: 'SelectedDOCInconsistentOnContractRate',
  TheSelectedDocumentIsNotTheSameVoyage: 'The selected document is not the same voyage/vessel',
  SelectTheData: 'Select the Data',
  NoSelectedDataOrAreNotOperationalStatus: 'No selected data or are not operational status',
  TheSelectedServicesIncludeLockedServices: 'The selected services include locked services',
  SureYouWantToRemoveTheCharge: 'Sure you want to remove the charge?',
  NoCostToRemove: 'No cost to remove.',
  NoBusinessOrIsNotOperationalState: 'No business or is not operational state.',
  MakeSureToDelegateTheBusiness: 'Make sure to delegate the business?',
  ErrorReadingInformation: 'InformationObtainedError.',
  OrderTypeChangeTip: 'After switching the order type, some filled data will be cleared. Are you sure to switch',
  BusinessDateCanNotNull: 'Business Date Can Not Null',
  TheReceivingPartyDoesNotMaintainTheCurrentCompanyInformationAmongPartners: 'The receiving Party does not maintain the current company information among partners',
  ElectronicEntrustmentHasBeenSentForThisBusinessSendAgain: 'Electronic entrustment has been sent for this business,send again?',
  DidNotFindTheCorrespondingTemplateTypeBOOKINGAndTemplateNameOceanExportBookingContinueToAuthorize: 'Did not find the corresponding template type [BOOKING] and template name [Ocean export booking], continue to authorize?',
  TheBranchCompanyOfCurrentBookingAgentDoesNotMaintainACorrespondingPartnerInThePartnership: 'The branch company of current booking agent does not maintain a corresponding partner in the partnership.',
  TheBranchCompanyOfCurrentForwardingAgentDoesNotMaintainACorrespondingPartnerInThePartnership: 'The branch company of current forwarding agent does not maintain a corresponding partner in the partnership.',
  TheBranchCompanyOfCurrentBookingAgentDoesNotMaintainACorrespondingPartnerInThePartnershipSI: 'The branch company of current destination agent does not maintain a corresponding partner in the partnership.',
  TheBranchCompanyOfUnExchangeAgent: 'The current branch of the exchange agent does not maintain a corresponding partner for our company in the partner list',
  TheBranchCompanyOfUnOurCompany: 'The current transportation company\'s subsidiary has not maintained a corresponding partnership with our company among its partners',
  TheOppositeSideHasScceptedNoNeedToReCommission: 'The opposite side has accepted, no need to re-commission.',
  SuccessfullySent: 'Sent Successfully.',
  NoSendingGoodsInfo: 'There is no cargo information that needs to be sent.',
  NoAssociatedBusiness: 'No associated business!',
  NoAssociatedContainerInfo: 'NoContainerVanningInfoNeedSend',
  PleaseEnterFleetInformatio: 'PleaseEnterTruckingInfo',
  ThisBoxIsNotAllowedToBeDeleted: 'ThisContainerNotAllowedDeletion',
  FailedToQueryTheAssociatedBusiness: 'NoAssociatedBizInfo.',
  RepeatedWarehouseNo: 'WarehouseInNumberDuplicated',
  NoStorageInfo: 'No storage information',
  TheJobIsIncorrectPleaseRefreshThePageOrContactTheAdministrator: 'WorkflowSheetIncorrectRefreshAndContactAdmin!',
  ConsignationCompanyCannotBeNull: 'Consignor Null Not Allowed',
  FLCLTypeCannotBeNull: 'ContainerTypeNullNotAllowed',
  POLCannotBeNull: 'POLNullNotAllowed',
  IfThereIsATransferTheTransferPortCannotBeNull: 'PortOfTransitNullNotAllowedForTransitCargo',
  PortOfDischargeCannotBeNull: 'PODNullNotAllowed',
  PortOfDestinationCannotBeNull: 'Port of destination cannot be null',
  SalesCannotBeNull: 'SalesPersonInfoNullNotAllowed',
  SalesBranchCompanyIsNullPleaseReSelectSales: 'Sales branch company is null, please select sales!',
  SalesDepartmentIsNullPleaseReSelectSales: 'Please select Sales Department!',
  DateOfDepartureCannotBeLaterThanDateOfArrival: 'Date of departure cannot be later than date of arrival',
  NominatedAgentCannotBeNull: 'Nominated agent cannot be null!',
  FLCLTypeCannotBeNull2: 'ContainerTypeNullNotAllowed!',
  ItemNoCannotBeNull: 'Item No cannot be null!',
  EQSizeCannotBeNull: 'ContainerTypeSizeNullNotAllowed!',
  EQSizeCannotBeNull2: 'There must be at least one box!',
  DearYouCanOnlySelectYourOwnCustomers: 'SelectOwnCustomerOnly.',
  DepartmentCannotBeNull: 'Department cannot be null!',
  CyCutoffDateCannotBeLaterThanDepartureDate: 'CutOffDateNotLaterThanDepartureDate',
  BargeCutoffDateCannotBeLaterThanCyCutoffDate: 'FeederVSLCutOffDateNotLaterThanCutOffDate',
  ContainerSealInfoHasBeenEnteredCannotBeDeleted: 'Container and seal information has been entered, cannot be deleted.',
  RelevantInstallationInfoHasBeenEnteredCannotBeDeleted: 'The relevant installation information has been entered and cannot be deleted.',
  TheChargedWeightHasBeenChangedThoseInvoicedAndBilledChargesWillNotBeUpdated: 'ChargeableWeightChangedRefreshOriginalExpenseAndNoUpdateInvoiceExpense.',
  TheChargedWeightHasBeenChangedThoseInvoicedAndBilledChargesWillNotBeUpdated2: 'ChargeableWeightChangedRefreshOriginalExpenseAndNoUpdateInvoiceExpense.',
  CurrencyChangeConfirm: 'Buy/Sell currency has changed. Refresh existing costs? Costs already billed, invoiced, payment requested, or written off will not be updated',
  PriceTypeChangeConfirm: 'Buy/Sell price type has changed. Refresh existing costs? Costs already billed, invoiced, payment requested, or written off will not be updated',
  PriceUpdateConfirm: 'The buying price/selling price has changed. Confirm whether to update the fees based on the charging weight per unit for the buying and selling prices? Fees for which bills, invoices, payment applications, and write-offs have been made will not be updated',
  TheChargedWeightHasBeenChanged: 'ChargeableWeightChangedRefreshOriginalExpense.',
  WeightChangeToRefreshCostBasedOnWeightPrice: 'Has the weight changed? Do you want to refresh the original cost based on weight? Expenses related to bills, invoices, payment requests, cancellations, and associated bills of lading will not be updated',
  WeightChangeToRefreshCostBasedOnWeightTonPrice: 'Has the weight changed? Do you want to refresh the original cost based on weight price (ton)? Expenses related to bills, invoices, payment requests, cancellations, and associated bills of lading will not be updated',
  CubageChangeToRefreshCostBasedOnCubagePrice: 'Has the volume changed? Do you want to refresh the original cost based on the volume price? Expenses related to bills, invoices, payment requests, cancellations, and associated bills of lading will not be updated',
  InsideQuantityChangeToRefreshCostBasedOnCubagePrice: 'Has the inside quantity changed? Do you want to refresh the original cost based on the volume price? Expenses related to bills, invoices, payment requests, cancellations, and associated bills of lading will not be updated',
  ChangeToRefreshCostBasedOnCubagePrice: 'If there are changes in the number of small items, gross weight, volume, and chargeable weight, will the original fees based on the number of small items, weight price, volume price, and chargeable weight price be refreshed? Expenses related to bills, invoices, payment requests, cancellations, and associated bills of lading will not be updated',
  DistributedSuccessfully: 'Distributed successfully',
  BusinessReferenceNoReduplicated: 'JobReferenceNoDuplicated',
  BookingAgentCannotBeNull: 'Booking Agent cannot be null',
  DateOfDepartureCannotBeNull: 'ETD cannot be null',
  TheMainInterfaceDoesNotExist: 'The main interface does not exist',
  FeesHaveBeenUsedForThisUnit: 'Fees have been used for this unit, please adjust the units of the relevant fees before deleting them',
  TheChargingUnitIsUsedByAnExistingChargePlan: 'The charging unit is used by an existing charge plan. Adjust the unit of the charge plan before deleting it',
  TheMasterBillBusinessNumberHasNotBeenGeneratedPleaseSaveTheTheMasterBillFirst: 'LCLMasterJobNoNotGeneratedSaveMasterShpt1st.',
  TheSubBillHasBeenConsolidatedAndCannotBeRemoved: 'ThisHouseShptConsolidatedNotAllowedRemoved.',
  PleaseSelectSubBills: 'SelectHouseShptPlease.',
  PleaseSaveTheChangedDataOrExitTheEditStateAndThenCloseTheModule: 'Please save the changed data, or exit the edit state, and then close the module.',
  replaceInvoiceRemarkRequired: 'Please input replacement invoice remark.',
  MblNoIsNull: 'MB/L No is null',
  SONoIsNull: 'S/O No is null',
  NoVesselVoyageInformation: 'No vessel/voyage information',
  ObtainSuccessfully: 'Obtain successfully',
  PleaseSelectCopyType: 'Please select copy type.',
  NoTargetShippingCompanyFoundHerePleaseRefreshTheCache: 'No target shipping company found here. Please refresh the cache!',
  BlIsConfirmed: 'B/LConfirmed.',
  ThisHblIsCombinedAndCannotBeEdited1: 'ThisHouseB/LCombinedAndEditNotAllowed.',
  ThisHblIsCombinedAndCannotBeEdited2: 'cannot be edited',
  ToOrederBlCannotBeTelexReleased: 'TO ORDER B/L cannot be telex released',
  PleaseInputBlSerialNumberFirst: 'Please input B/L serial number first!',
  PleaseSelectTheListToBeMergedInto: 'PleaseSelectDOCNeedsCombined!',
  PleaseInputBussinessNo: 'PleaseEnterJobNumber!',
  NoSelectedContainerInformation: 'No selected container information.',
  PleaseSelectData: 'Please select data',
  OnlySelectOneData: 'Only select one data',
  Count: 'Count',
  AreYouSureYouWantToRemoveTheSubBill: 'MakeSureToRemoveThisHouseShpt?',
  RemovedSuccesfully: 'Removed succesfully.',
  NoSubBillsToSplit: 'NoHouseShptToBeSplited.',
  SoNoCannotBeNull: 'MasterB/LNo.NullNotAllowed.',
  CancelTheCurrentQuery: 'Cancel the current query?',
  SelectTheOrderYouWantToJoin: 'Select the order you want to join',
  HasJoinIntoMbl: 'AddedIntoMasterShpt.',
  TheSubBillsAndMBLAreInconsistentTheSystemWillModifyTheSubBillsContinue: 'ThisNewSelectedHouseShptInconsistentOnVSLVoyageCarrierBookingAgentDeliveryAgentETDETAWarehouseWithMasterShptModifyBySystemContinueStill?',
  ContainerNoDoesNotComplyWithTheNumberingRules: 'Container No does not comply with the numbering rules.',
  SealNoHasBeenChanged: 'Seal No has been changed.',
  PleaseSelectTheDesiredPrintVgm: 'SelectVGMtoPrint.',
  DeleteTheVgmInformation: 'Delete the VGM information?',
  PleaseEnterEnglish: 'Please enter English.',
  PleaseEnterTheShippingCompanyInformation: 'Please enter the shipping company information!',
  SameJobtruckOrderNo: 'DoorToDoorContainerTruckNumberDuplicatedAmendPlease!',
  SureYouRemoveThisNData1: 'Sure you remove this',
  SureYouRemoveThisNData2: 'data?',
  AreYouSureYouWantToSendACarOrder: 'MakeSureDispatchTruckingNumber?',
  AreYouSureYouWantToModifyACarOrder: 'MakeSureModifyTruckingNumber?',
  AreYouSureYouWantToRevokeACarOrder: 'MakeSureToWithdraw?',
  ThisCarOrderIsSended: 'DispatchAgainNotAllowedModifyDemandOnly.',
  ThisCarOrderCanOnlyBeModifiedAfterSending: 'ModifyDemandAfterDispatchedOnly.',
  ThisCarOrderIsSendedNoAddUsage: 'AddContainerNotAllowedAfterDispatched.',
  ThisCarOrderCanOnlyBeRevokedIsUnApproved: 'WithdrawOnlyBeforeTruckingAcceptance.',
  ThisCarOrderIsChanged: 'ReceiptDataChanged',
  DeleteFailed: 'Delete failed',
  Failure: 'Failure',
  DispatchSuccess: 'Dispatch success',
  ModifiedTruckOrderSuccess: 'ModificationSuccess',
  RevokeTruckOrderSuccess: 'WithdrawSuccess',
  DispatchFailed: 'MatterOnDispatch',
  ModefiedTruckOrderFaild: 'MatterOnModification',
  RevokeTruckOrderFaild: 'MatterOnWithDraw',
  VgmWeightingMethod: 'VGM weighing method',
  LdpWarn: 'For frozen goods at least one line is required at the same time',
  WxpWarn: 'For dangerous goods at least one line is required at the same time',
  Transfer: 'Shipping agent vessel change',
  ReasonForDeletion: 'Reason for deletion',
  ReasonForDeletionNotEmpty: 'Reason for deletion cannot be empty',
  VesselRegex: 'Must be uppercase/lowercase letters and digits, max 35 characters',
  BlNumberRegex: 'Digits only',
  DanClass: 'Must be between 1 and 9.9',
  CubageRegex: 'Must be between 0.001 and 2000.999',
  RowPrefix: 'Customs declaration No.{0}',
  UpdateVesselVoyNo: 'Update vessel voyage number',
  UpdateVesselVoyNoError: 'Cannot update vessel voyage number for unsent manifest',
  InputVesselVoyNo: 'Please enter the updated vessel voyage number',
  ShipNotRegistered: 'Vessel not registered',
  LoadManifest: 'Load manifest',
  ModificationFailed2: 'Re-stowage failed',
  ModifiedSuccessfully: 'Re-stowage successful',
  NoDelete: 'No data available for sending manifest deletion',
  SendFailed: 'Send Failed',
  SaveFailed: 'Save Failed',
  ViewWarehouseEntryPhotos: 'View warehouse photos',
  DistributeFailedNoFoundRelatedStorageRecord: 'Distribute failed, No found related storage record!',
  SureYouWantToCancelTheBindingToTheStorageData: 'Are you sure you want to cancel the binding to the storage data?',
  QueryFailed: 'Query failed',
  SelectDeclarations: 'Select declarations.',
  SelectCustomsInformation: 'Select customs information.',
  SelectCustomsRecord: 'Select customs record.',
  TheNumberOfTenBitCodeYouEnteredIsNotEnough: 'Oh, well, the number of ten bit code you entered is not enough.',
  OperatingCompanyCannotBeNull: 'ShipperNameNullNotAllowed.',
  DateOfCustomsDeclarationCannotBeNull: 'Date of customs declaration cannot be null.',
  PleaseSelectStatusOfCustomsDeclaration: 'Please select status of customs declaration.',
  CargoDetailsWEIGHTBannotBeNull: 'GoodsDescriptionWEIGHTNullNotAllowed',
  CargoDetailsAMOUNTBannotBeNull: 'GoodsDescriptionAMOUNTNullNotAllowed',
  CargoDetailsCustomsDutyRateBannotBeNull: 'GoodsDescriptionCustomsDutyRateNullNotAllowed',
  CargoDetailsCustomsDutiesBannotBeNull: 'GoodsDescriptionCustomsDutyNullNotAllowed',
  CargoDetailsIncrementRateCannotBeNull: 'GoodsDescriptionVATRateNullNotAllowed',
  CargoDetailsIncrementValueDutyBannotBeNull: 'GoodsDescriptionVATNullNotAllowed',
  CargoDetailsConsumptionDutyRateBannotBeNull: 'GoodsDescriptionConsumptionTaxRateNullNotAllowed',
  CargoDetailsConsumptionDutyBannotBeNull: 'GoodsDescriptionConsumptionTaxNullNotAllowed',
  CargoDetailsCurrencyBannotBeNull: 'GoodsDescriptionCurrencyNullNotAllowed',
  CargoDetailsExchangeBannotBeNull: 'GoodsDescriptionExchangeRateNullNotAllowed',
  CargoDetailsCargoPriceBannotBeNull: 'GoodsDescriptionGoodsPriceNullNotAllowed',
  CargoDetailsTaxBannotBeNull: 'GoodsDescriptionTaxNullNotAllowed',
  CargoDetailsTaxRateBannotBeNull: 'GoodsDescriptionTaxRateNullNotAllowed',
  ImportSuccessful1: 'Import successful',
  ImportSuccessful2: ' item',
  ImportFailed: 'Import failed',
  CargoDetailsIsNotSelected: 'Cargo details is not selected.',
  PleaseSelectUnRelatedTradeDetailData: 'Please select unrelated data',
  SelectTheBillingObject: 'Select the billing object',
  NoChargeForTheSettlementOfDomesticObjects: 'No charge for the settlement of domestic objects.',
  CancelAudit: 'Cancel audit',
  ChargesAudit: 'Charges audit',
  ThereAreFeesCantBeDeletedPleaseRecheck: 'There are fees can\'t be deleted, please re-check.',
  TheChargesHaveBeenSettledByFinancialAccountAndCannotBeAmended: 'ExpenseSettledNotAllowedAdjustment.',
  RedChargeOrRedChargedCannotBeEditAdjustAgainPleaseSelectNewAdjustment: 'ChargeOrChargedOffExpensesNotAllowedAdjustmentSelectAdded.',
  RedChargeOrRedChargedCannotBeDeletedPleaseReselect: 'ChargeOrChargedOffExpensesNotAllowedDeletionReSelect.',
  PleaseRefresh: 'The fee has been modified by others, please refresh',
  ChargeItemCannotBeNull: 'ExpenseNameNullNotAllowed!',
  MeasureCannotBeNull: 'MeasureCannotBeNull！',
  SettlementPartyCannotBeNull: 'Settlement Object Null Not Allowed!',
  CurrencyCannotBeNull: 'CurrencyNullNotAllowed!',
  AmountCannotBeNull: 'The unit price is not filled in and cannot be saved.',
  UnitRateCannotBeNull: 'Unit rate cannot be null!',
  CustomsSeclarationServiceIsNotSelectedInBookingCannotAdd: 'BookingNoNeedCustomsClearanceServiceCanNotAdd:',
  WaerhouseServiceIsNotSelectedInBookingCannotAdd: 'BookingNoNeedWarehousingServiceCanNotAdd:',
  HaulageServiceIsNotSelectedInBookingCannotAdd: 'BookingNoNeedTransportationServiceCanNotAdd:',
  ChargeIsNotSelectedOrAllChargesSubmit: 'NoExpenseSelectedOrAllSubmitted.',
  ChargeIsNotSelectedOrNotInTheSubmissionStatus: 'NoExpenseSelectedOrNotSubmissionStatus.',
  OperationSuccessfully: 'Operation successfully',
  PayablesIsNull: 'Payables is null.',
  ReceivalbeIsNull: 'Receivalbe is null.',
  CopyThePayablesSuccessfullyTotallyOfNItems1: 'Copy the payables successfully, totally of',
  CopyThePayablesSuccessfullyTotallyOfNItems2: 'items',
  CopyTheReceivablesSuccessfullyTotallyOfNItems1: 'Copy the receivables successfully, totally of',
  CopyTheReceivablesSuccessfullyTotallyOfNItems2: 'items',
  NoPayablesCanBeCopiedThereMayBeSameChargeItems: 'No payables can be copied, there may be same charge items.',
  NoReceivablesCanBeCopiedThereMayBeSameChargeItems: 'No receivables can be copied, there may be same charge items.',
  CopyChargeSuccessfullyTotallyOfNItems1: 'Copy Charge successfully, totally of',
  NoChargeCanBeCopiedThereMayBeSameChargeItems: 'No Charge can be copied, there may be same charge items.',
  TheCurrentlyRelevantBusinessInformationIsNull: 'The currently relevant business information is null.',
  PleaseSelectCharges: 'Please select charges.',
  SelectChargesAreInControl: 'Select charges are in control',
  SelectedChargesAreCancelledControlling: 'Selected charges are cancelled controlling',
  PleaseGoToTheFCLFreightInquiryModuleToCheckFreightDetails: 'Please go to the FCL freight inquiry module to check freight details!',
  PleaseGoToTheAirFreightInquiryModuleToCheckFreightDetails: 'Please go to the air freight inquiry module to check freight details!',
  DoYouNeedToInviteOthersToConfirmTheCharges: 'Do you need to invite others to confirm the charges?',
  TheMailHasBeenSentPleaseNoteAndHaveACheck: 'The mail has been sent. Please note and have a check!',
  PleaseSelectReceivableCharges: 'Please select receivable charges',
  PleaseSelectPayableCharges: 'Please select payable charges',
  OnlyAuditChargesHaveBeenSubmitted: 'Only audit charges have been submitted',
  NoChargesToAudit: 'No Charges To Audit',
  NoChargesToUnAudit: 'No Charges To Un Audit',
  NoChargesToReject: 'No Charges To Reject',
  YouAreNotACostSpecifiedByTheReviewerCannotAuditTheCharges: 'MakeSureYouAuditorOfAllExpenses',
  SelectedExpensesIncludeAllWriteOffExpensesWhetherToAddThemToTheBill: 'Selected expenses include all write-off expenses, whether to add them to the bill?',
  AllSelectedFeesWillBeVerifiedPleaseChooseAgain: 'All selected fees will be verified. Please choose again',
  IncludeFullyWrittenOffCosts: 'The selected costs include fully written-off amounts. Add them to the invoice?',
  AuditSuccessfully: 'Audit successfully',
  CancelSuccessfully: 'Cancel successfully',
  PleaseSelect1ChargeDetail: 'Please select1 charge detail.',
  NoPriceToMeetTheQueryCriteria: 'No price to meet the query criteria.',
  Prepaid: 'FreightPrepaid',
  Collect: 'FreightCollect',
  PrePayTheSamePrice: 'SameFreightRateOfPPAndCC',
  RefreshRateFailed: 'Refresh rate failed!',
  PleaseSelectThePrice: 'Please select the price!',
  Invalidation: 'Invalidation',
  Normal: 'Normal',
  suspension: 'suspension',
  NoPickingUp: 'NotReceiveGoods',
  Inquiry: 'Inquiry',
  Tension: 'Tension',
  OverStowage: 'Overbooking',
  CreateBill: 'Create account documents by expense currency',
  SplitBill: 'Generate bill by original currency splitting',
  PleaseBeNotedThatThisRateIsUnderSuspendSailing: 'Please be noted that this rate is under suspend sailing',
  PleaseBeNotedThatThisRateIsUnavailableNow: 'Please be noted that this rate is unavailable now.',
  PleaseBeNotedThatThisRateIsOnlyForPartOfEQType: 'Please be noted that this rate is only for part of EQ type.',
  PleaseBeNotedThatThisRateIsUnderOverbookedStatus: 'Please be noted that this rate is under overbooked status.',
  TheOriginOfSelectedRateIsDifferentFromBookingAgent: 'The origin of selected rate is different from booking agent.',
  Unconfirmed: 'Unconfirmed',
  Confirmed: 'Confirmed',
  Receivable: 'Receivable',
  Payable: 'Payable',
  Bill: 'Bill',
  TheBillDoesNotConfirm: 'The Bill does not confirm',
  SureYouWantToCancel: 'sure you want to cancel?',
  StateModifiedSuccessfully: 'State modified successfully.',
  NoInternalCostsToBilling: 'No internal costs to billing',
  NoSettlementUnit: 'No settlement unit.',
  CheckoutObjectIsNullNoAdditionalCostsConfirmationSlip: 'Checkout object is null, no additional costs confirmation slip.',
  ClearingUpInvoicingInformationWasNotSuccessfullyRead: 'Clearing up invoicing information was not successfully read.',
  YouDontHavePermissionToEditBills: 'NotAllowedEditPayableBill.',
  YouDontHavePermissionToDeleteBills: 'NotAllowedDeletePayableBill.',
  HaveNoPermissionToDeleteBillsCreatedByOtherUsers: 'Have no permission to delete bills created by other users',
  NoSelectedBill: 'No selected bill.',
  ClearingTheObjectDoesNotExistPleaseTryResettingTheCache: 'Clearing the object does not exist, please try resetting the cache.',
  BillSaveSuccessfully: 'Bill save successfully.',
  BillingObjectIsNull: 'Billing object is null.',
  ChargeCannotBeEmpty: 'ExpenseNullNotAllowed',
  TaxesAndTaxRatesDoesNotMatchTheData: 'TaxAmountTaxRateDatasInconsistent.',
  InvoicingHeadCannotBeEmpty: 'InvoiceTitleNullNotAllowed',
  CurrencyExchangeRateIsNotMaintained1: 'Currency',
  CurrencyExchangeRateIsNotMaintained2: 'exchange rate is not maintained.',
  FeeCurrencyMustBeTheSame: 'ExpenseCurrenciesMustBeConsistent.',
  NoForeignFeeBilling: 'No foreign fee billing.',
  ThisJobIsNotWorkingCanNotBeDeleted: 'This job is not working, Can not be deleted.',
  SureYouWantToDeleteTheBilling: 'Sure you want to delete the billing?',
  SureAuditTheBill: 'Sure audit the Bill?',
  ThisBillWasSubmittedToTheFinancialAuditAndCannotBeVoided: 'This Bill was submitted to the financial audit, and cannot be voided.',
  ThisOrderHasBeenRevokedNotARepeatedAction: 'This order has been revoked, not a repeated action.',
  DomesticBillsCannotBeVoided: 'Domestic bills cannot be voided',
  TheBillHasBeenConfirmedAndCannotBeVoided: 'The bill has been confirmed and cannot be voided',
  ThisVerificationHasBeenDoneAndCannotBeVoided: 'This verification has been done and cannot be voided.',
  AccountIsClosedAnyOperationIsNotAllowed: 'account is closed, any operation is not allowed.',
  ThisFormIsLockedAndCannotBeVoided: 'This form is locked and cannot be voided',
  ThisFormIsLockedAndBillingGroup: 'This form is locked and billing group',
  ConfirmTheCancellationOfTheBill: 'Confirm the cancellation of the bill?',
  ConfirmTheCancellationOfTheBill2: 'Are you sure to void the selected bill?',
  TheBillHasBeenRevoked: 'The Bill has been revoked.',
  NoSelectSettlement: 'No selected settlement.',
  BillOfExchangeCannotBeEmpty: 'Bill of Exchange cannot be empty.',
  CollectingAdvanceBillingAndGeneralExpensesCannotBeTogether: 'Collecting advance billing and general expenses cannot be together.',
  TheBillNumberIsCreatedSuccessfully: 'The bill number is created successfully',
  TheWordCorrespondingNetworkNameOrTheOverseasAgentNetworkManagementCodeHasNotBeenMaintained: 'The word corresponding network name or the overseas agent network management code has not been maintained',
  EnterTheShareProportion: 'Enter the share proportion.',
  PleaseSelectACurrency: 'Please select a currency.',
  PleaseEnterTheBillingObject: 'Please enter the billing object',
  PleaseAddCosts: 'Please add costs.',
  TheAmountOfBillCannotBeEqualTo: 'The Amount of Bill cannot be equal to 0',
  PleaseEnterTheNameOfTheCosts: 'Please enter the name of the costs.',
  PleaseEnterTheQuantityOfTheCosts: 'Please enter the quantity of the costs.',
  PleaseEnterThePriceOfTheCosts: 'Please enter the price of the costs.',
  PleaseSelectTheCostToRemove: 'Please select the cost to remove.',
  CollectingInconsistentWithTheTotalAdvance: 'Collecting inconsistent with the total advance!',
  TheBillHasBeenInvoicedAndCannotBeDeleted: 'The Bill has been invoiced and cannot be deleted',
  LoadFailed: 'Load failed',
  PlatformCodeAlreadyExists: 'Platform code already exists！',
  NameCannotBeRepeated: 'The Chinese name or English name of the collection and payment account cannot be repeated!!!',
  ChineseNameCannotBeBlank: 'The Chinese name of the collection / payment account cannot be blank!!!',
  CannotBeModified: 'It has been used by business. Its name cannot be modified',
  PleaseSelectAServiceItem: 'Please select a service item',
  Overseas: 'Overseas',
  Domestic: 'Domestic',
  PleaseSelectTheDesiredPrintInformation: 'Please select the desired print information',
  ThereIsAnErrorReadingWriteOffInformation: 'There is an error reading write off information.',
  TheBookingDoesNotExistAndCannotBeAdded: 'The booking does not exist and cannot be added.',
  PleaseEnter: 'Please enter at least two characters before starting the query',
  PleaseEnterTheCode: 'Please enter code, name and other fuzzy query...',
  PleaseEnterTheCode2: 'Please enter (at least two characters) code, name and other fuzzy queries...',
  PleaseEnterTheContent: 'Please enter the content',
  PleaseSelectDataBeforeOperation: 'Please select data before operation',
  NoPortRecordMeeting: 'No port record meeting the requirements is selected, please select again!',
  DeleteTheSelectedRecord: 'Delete the selected record',
  DoYouConfirmThatYouWantToDelete: 'Do you confirm that you want to delete?',
  DeletionCancelled: 'Deletion cancelled',
  EditCancelled: 'Edit cancelled',
  PleaseSelectARecordToEdit: 'Please select a record to edit',
  PleaseFillInTheCorrectFiveDigitPortCode: ' Please fill in the correct five digit port code. ',
  DeleteFail: 'Delete failed!',
  DeleteSucceeded: 'Deleted successfully!',
  DisplayRuleCannotBeEmpty: 'Display rule cannot be empty!',
  OperationRequirementsCannotBeEmpty: 'Operation requirements cannot be empty!',
  OperationRequirementsCannotBeGreaterThan: 'The length required for operation cannot be greater than 2048 bits!',
  NewPortRequestSucceeded: 'New port request succeeded',
  EditPortRequestSucceeded: 'Port requirements modified successfully',
  ConfirmDelete: 'Confirm Delete',
  IsItUsedForMAWB: 'Is it used for MAWB',
  IsItUsedForHAWB: 'Is it used for HAWB',
  AddPortRequirementsAirport: 'Add port requirements (Airport)',
  EditPortRequirementsAirport: 'Edit port requirements (Airport)',
  PleaseSelectARecordToDelete: 'Please select a record to delete',
  BackPageTip: 'Returning to the previous page will delete the information you have entered on the insurance application page. Are you sure you want to go back',
  WarmReminder: 'Warm Reminder',
  GoBack: 'Go Back',
  ReturnToHomepage: 'Return To Homepage',
  HomepageNotSupportImport: 'The homepage of freight insurance does not currently support importing insurance directly',
  PortInformationEditedSuccessfully: 'Port information edited successfully',
  AirlineInformationEditedSuccessfully: 'Successfully edited airline information',
  SuccessfullyAddedAirlineInformation: 'Successfully added airline information',
  SuccessfullyAddedPortInformation: 'Successfully added port information',
  GetBack: 'Get back',
  FailedToInquiryCustomsDeclarationInformation: 'Failed to inquiry customs declaration information:',
  PleaseSelectARecord: 'Please select a record.',
  NewDocuments: 'New Documents',
  EditDocuments: 'Edit Documents',
  FileTypeCannotBeEmpty: 'File Type cannot be empty!',
  FileNumberCannotBeEmpty: 'File No cannot be empty',
  FileNumberAlreadyExists: 'File No already exists.',
  DataEnabledSuccessfully: 'Data enabled successfully.',
  DataDisabledSuccessfully: 'Data disabled successfully.',
  Error2: 'Error',
  TheDocumentHasBeenSaved: 'The document has been saved',
  TheCustomsBrokerCannotBeEmpty: 'The customs broker cannot be empty.',
  NoInformationCanBeQueried: 'No information can be queried.',
  ErrorSavingBusinessState: 'Error saving business State',
  OrderInformationWasSuccessfullyUpdated: 'Order information was successfully updated.',
  NoExternalUpdateInformation: 'No external update information',
  ExternalInformationWasSuccessfullyUpdated: 'External Information was successfully updated',
  NodeStatusIsNotPreserved: 'Node status is not preserved.',
  TheNodeAffinityForTheMailTemplateIsNotMaintained: 'The node affinity for the mail template is not maintained.',
  DoNotLocateAnAssociatedPrintTemplateType: 'AssociatedPrintTemplateNotFound.',
  TheEmailWasSentPleaseNoteTheQuery: 'The E-mail was sent, please note the query!',
  PleaseSelectAFile: 'Please select a file!',
  SureYouWantToDeleteFiles: 'Sure you want to delete files?',
  EmailAddressCannotBeEmpty: 'Email address cannot be empty.',
  UploadSuccess: 'Upload Success:',
  UploadFailed: 'Upload Failed:',
  FileSizeExceedsMBYouCannotUpload: 'file size exceeds 20MB, you cannot upload.',
  DoNotSelectedCategory: 'do not selected category.',
  PleaseSelectAJob: 'Please select a job.',
  PleaseSelectTheSameTypeOfJob: 'Select the same type of work orders.',
  NotStart: 'Not Start',
  PleaseSelectABusinessStatus: 'Please select a business status',
  PleaseSelectABusinessStatusDetails: 'Please select a business status details',
  EditedSuccessfully: 'Edited Successfully',
  PleaseContactTheSuperiorUnlocked: 'ThisJobOverdueLockedAskSuperiorUnlock!',
  CanSuccessfullyPrint: 'PrintedSuccessfulOrNot?',
  ConfirmToPrint: 'Confirm to print',
  CorrespondsToThePrintTemplateDoesNotFind: 'NoCorrespondingPrintTemplateFound',
  FailedToGetTheTemplateType: 'Failed to get the template type!',
  NoSelectedTemplate: 'No selected template.',
  BulkTransshipmentSuccessWhetherYouWantToCloseThePopUpWindow: 'BatchTransitSuccessClosePop-UpsOrNot',
  BulkTranferSuccessWhetherYouWantToCloseThePopUpWindow: 'Bulk tranfer success, whether you want to close The pop up window',
  NoFeesCanBeDeleted: 'No fees can be deleted.',
  NoSelectedCharge: 'No Selected Charge.',
  NoChargeCanBeSaved: 'No charge can be saved.',
  ChargeNameCannotBeEmpty: 'Charge name cannot be empty.',
  ClearingTheObjectCannotBeNull: 'SettlementObjectNullNotAllowed.',
  BusinessNumberIs0: 'JobNumberQuantityIsZero.',
  CustomerIsNULL: 'Customer is NULL,',
  TheCarrierIsEmpty: 'The carrier is Null,',
  AgentIsNULL: 'BookingAgent/DeliveryAgentNull,',
  AgentIsNULL2: 'OverseasAgent/DeliveryAgentNull,',
  CustomsIsNull: 'CustomsBrokerNull,',
  TerminalCompanyIsNull: 'TerminalCompanyNull,',
  TheObjectCannotBeUsedAsTheDefaultSettlement: 'CannotAsTolerantSettlementObject.',
  AddSuccessfully: 'Add Successfully',
  DisplaysTheCostOfUpdatingResults: 'Displays the cost of updating results',
  TotalCost1: 'Total cost:',
  TotalCost2: ',',
  Updated1: 'Updated:',
  Updated2: ',',
  NotUpdated1: 'Not updated:',
  NotUpdated2: '.',
  NotMatchingTheCostOfTheProjectCanBeAdded: '<i class="el-icon-info" style="font-size: 16px;"></i><span style="font-size: 14px;margin-left: 5px;">Not matching the cost of the project</span><b style="font-size: 16px;">&nbsp;can be added</b>',
  ChargeWasSuccessfullyUpdated: 'Charge Was Successfully Updated.',
  NotMatchingTheCostOfTheProjectCanBeUpdated: 'Not matching the cost of the project can be updated.',
  NoAddedCharge: 'No added charge.',
  DefaultValuesAreSavedSuccessfully: 'Default values are saved successfully.',
  ContSigned: '(Cont. Signed)',
  ContUnsigned: '(Cont. Unsigned)',
  InvalidCont: '(Invalid Cont.)',
  TheSystemHasBeenUpdatedPleaseRefreshThePage: 'The system has been updated, please refresh the page!',
  PleaseInputCosts: 'Please input costs.',
  SelectTheSurchargeClause: 'Select the surcharge clause.',
  HAWBCannotBeNull: 'AMS NO cannot be empty',
  ENSHblNbr2CannotBeNull: 'ENS NO cannot be empty',
  HAWBCannotBeRepeated: 'HAWB cannot be Repeated!',
  HAWBAfrCannotBeNull: 'HB/L NO cannot be empty',
  HAWBAfrCannotBeRepeated: 'HB/L NO cannot be Repeated!',
  InlandCannotBeNull: 'Inland Location Depository Null Not Allowed!',
  rocordNumberCannotBeNull: 'Canadian customs record number cannot be null',
  AreYouSureYouWantToDelete1: 'Are you sure you want to delete',
  SureDeleteHbl: 'The order cannot be recovered after being deleted. Do you want to delete it?',
  AreYouSureYouWantToDelete2: '?',
  PleaseSelectTheAMSNO: 'Please select the AMS NO.',
  PleaseSelectTheHBLNO: 'Please select the HB/L NO.',
  TheMaximumCannotExceedLines: 'The maximum cannot exceed 5 lines!',
  DisplayColumn: 'CustomizedDisplayColumn',
  Display: 'Display',
  Name: 'Name',
  TradeCommissionedUnitCannotBeEmpty: 'ShipperNameNullNotAllowed',
  TradeSalesSupportCannotBeEmpty: 'TradeSalesSupportNullNotAllowed',
  TradingCurrencyCannotBeEmpty: 'Trading-Currency cannot be empty',
  TradingExchangeRateCannotBeEmpty: 'Trading-Exchange rate cannot be empty',
  TradeServiceFeeDiscountRateCannotBeEmpty: 'Trade-service fee discount rate cannot be empty',
  TradeTheAmountOfWriteOffsCannotBeGreaterThanTheAmountOfOrders: 'Trade-The Amount Of Write Offs cannot be greater than the amount of orders',
  TradePaymentNOCannotBeEmpty: 'Trade-payment No. cannot be empty',
  TradePaymentNumberCannotBeGreaterThanBitsInLength: 'Trade-payment number cannot be greater than 16 bits in length',
  UnableToDeleteAllCharges: 'Unable to delete all charges.',
  PleaseCheckYourNetworkOrRefreshThePage: 'Please check your network or refresh the page.',
  TheFileIsSentSuccessfully: 'The file is sent successfully.',
  PleaseSelectAFileToDownloadOrSend: 'Please select a file to download or send.',
  PleaseSelectAFileSynchronization: 'Please select a file to synchronization.',
  PleaseSelectAFileCancelSynchronization: 'Please select a file to cancel synchronization.',
  FailedToModifyAFileType: 'Failed to modify a file type.',
  PleaseSelectAFileType: 'Please select a file type.',
  MBLNOCannotBeDuplicated: 'MB/L NO2 cannot be duplicated!',
  PleaseSelectMBLNo: 'Please select MBL No.',
  TotalWeightOfLadingAreInconsistent: 'The total amount on the bill of lading is inconsistent!',
  TOORDERIsUnavailableToRelease: 'ToOrderB/LTelexReleaseNotAllowed',
  TheAssociatedPrimaryFormIsNotSelected: 'NotSelectAssociatedMasterB/L',
  PleaseSelectHBLNo: 'Please select HBL No.',
  PleaseEnterTheBillOfLadingSerialNumber: 'Please enter the Bill of Lading serial number!',
  PleaseUploadReleaseGuarantee: 'There is no valid telex release guarantee, please upload first',
  TheRecipientAddressCannotBeEmpty: 'ConsigneeAddressNullNotAllowed',
  OperationIsNotReversible: 'OperationStatusIrreversible',
  Uncommitted: 'Uncommitted',
  Approved: 'Approved',
  Submitted: 'Submitted',
  Rejected: 'Rejected',
  PleaseSelect: 'Please Select',
  Uploaded: 'Uploaded',
  Waiting: 'Waiting for upload',
  Uploading: 'Uploading',
  Other: 'Other',
  First: 'First',
  Pre: 'Pre',
  Page: 'Page',
  AllPage1: 'Total',
  AllPage2: 'Page',
  Next: 'Next',
  Last: 'Last',
  ShowFromTo1: 'From',
  ShowFromTo2: 'to',
  AllRecord1: 'Total',
  Transactions: 'transactions',
  AllRecord2: 'Record',
  Convert: 'Convert',
  YouAreUnableToUseThisFunctionAsWHHasntBeenConfiguredIfNeedPleaseContactCSOnline: 'CannotUseWarehouseFunctionUnconfiguredContactAdmin.',
  FirstSaveTheBusinessAutomaticLoadingIsInProgress: 'AutoDistributeAfterSaved.',
  FirstSaveTheBusinessAddSpecialGoods: 'AddDangerousCargoAfterSaved',
  GeneralTrade: 'general trade',
  ProcessingWithSuppliedMaterial: 'processing with supplied material',
  ProcessingTrade: 'processing trade',
  SamplesOfAdvertisingProductsA: 'Samples of advertising products A',
  Refuse: 'Refuse',
  Agree: 'Agree',
  GoOn: 'Go On',
  SubmitAudit: 'Submit to Supervisor for Audit',
  DataValidation: 'DataVerifying',
  DataValidatedWithWarning1: 'DataVerified With Warning Continue Or Not',
  DataValidatedWithWarning2: 'or Cancel to cancel',
  DataValidatedWithWarning3: 'Please click [Cancel]',
  DataValidatedSuccessfully1: 'Data Verified Successful Confirm',
  DataValidatedSuccessfully2: 'or Cancel to cancel',
  DataValidatedSuccessfully3: 'Please click [Cancel]',
  DataValidatedFailure1: 'DataVerify Failed,Handle The Itmes Unsanctioned',
  DataValidatedFailure2: 'after validating again',
  WoChat: 'WoChat',
  TheSystemHasBeenUpdatedPleaseTurnTheModuleOnAgain: 'The system has been updated, please turn the module on again.',
  TheSystemHasBeenUpdatedPleaseReLoginOrClearBrowserCache: 'The system has been updated, please reLogin or clear browser cache.',
  AddAdjustment: 'Add Adjustment',
  AddCharge: 'Add Charge',
  EditAdjustment: 'Edit Adjustment',
  EditCharge: 'Edit Charge',
  DeleteAdjustment: 'Delete Adjustment',
  DateOfAdjustmentCannotBeNull: 'Date of adjustment cannot be null.',
  CurrencyOfAdjustmentCannotBeNull: 'Currency of adjustment cannot be null.',
  AmountCannotBeZero: 'Amount cannot be zero.',
  UnitPriceCannotBeZero: 'Unit price cannot be zero',
  AmountCannotBeZero2: 'Amount cannot be zero.',
  ExchangeCannotBeZero2: 'Exchange Rate cannot be zero.',
  RemarkTheLengthCannotExceed: 'Remark the length cannot exceed 50.',
  InvoiceNoCannotBeNull: 'Invoice No cannot be null.',
  InvoiceNoIsTooLong: 'Invoice No is too long.',
  PleaseAddSpecialGoodsFirst: 'Please add a special goods at first.',
  UNNoIsEmpty: 'Please fill in the UNNo.',
  LoadSpGoodsContainerError: 'Loading special goods container information error.',
  AssociatedSpGoodsError: 'Associated special goods information error.',
  NoAssociatedInfo: 'No associated information.',
  InnerPackagingTypeIsRequired: 'Inner packaging type is required.',
  InnerPackagingQuantityIsRequired: 'Inner packaging quantity is required.',
  SeaPollutionOnlyEnterYN: 'The value of Ocean pollution field must be Y or N.',
  SelectHsCode: 'Select HSCode',
  SelectCargoChineseName: 'Select CargoChineseName',
  DispatchNotYet: 'Modify order is not allowed.',
  AllDataMustBeOperating: 'All data must be in a positive operating state',
  TheSelectedDocumentInconsistentNatureOfTheContainerLoadType: 'The selected document inconsistent nature of the container load type',
  TheNumberOfChargesLimited: 'The maximum amount can not exceed',
  TheNumberOfSelectedDataLimited: 'The maximum amount of selected items can not exceed',
  PleaseInputSearchCondition: 'Please enter query conditions',
  PlaceOfDeliveryCannotBeNull: 'Port of delivery cannot be null',
  ImportSuccessChargesCount: 'Successful Import Of {count} Charges',
  CheckChargeDetailBranch: 'The data that is being operated is not part of the current branch or the upper branch.',
  ChangeSelectSales: 'Does the sales change continue to be kept�?',
  NoSelectedCargoDocInformation: 'No selected cargoDoc information.',
  OverseaCostChargeEmpty: 'OverSea Cost Charge Empty',
  OverseasBillsCanNotBePrinted: 'Overseas bills can\'t be printed',
  CheckHBLReleaseStateBeforePrint: 'No SingleRelease，can\'t be printed!',
  NoSelectedWarehouseInInformation: 'No selected warehouse in information!',
  NoWarehouseInInformation: 'No warehouse in information!',
  ConfirmTheShutOut: 'Please confirm the shut out?All of charges will be deleted!',
  SaveSucceed: 'Save Succeed!',
  SelectOneJob: 'Only allow one job to be copied!',
  PleaseInputETD: 'Please select a date range for ETD!',
  SelectJob: 'Please select job.',
  DateToday: 'Today',
  PleaseSelectSoNo: 'Please Select SoNo',
  ChargeOffsetState: 'The cost has flushed or been flushed.',
  isDeleteAllEDIContainer: 'Clear all container information',
  ServiceCodeCannotBeNull: 'ServiceCode cannot be null',
  Choose: 'Choose',
  ThisBillWasSubmittedToTheFinancialAuditAndCannotBeForceDel: 'This Bill was submitted to the financial audit, and cannot be force delete.',
  ThisVerificationHasBeenDoneAndCannotBeForceDel: 'This verification has been done and cannot be force delete.',
  ThisFormIsLockedAndCannotBeForceDel: 'This form is locked and cannot be force delete.',
  ConfirmTheForceDelOfTheBill: 'Confirm the force delete of the bill?',
  ForceDelSuccessfully: 'Force delete successfully',
  IsNotOperationStatusCannotBeShutOut: 'Only batch shut out businesses in the "Operating" state',
  IsNotOperationStatusCannotBeCancellation: 'Only batch cancellation businesses in the "Operating" state',
  ManifestLink: 'The manifest link is as follows',
  ApplicationAmountCheck: 'Payment application amount does not match the total amount of expense list, please check!',
  TipsOnSplittingExpenses: 'Split expense amount cannot be greater than the original expense amount, please modify the split expense amount!',
  DcCopyCheck: 'The business document information is incomplete, please re select business copy!',
  CsrCopyCheck: 'The customer service information of this business is incomplete, please re select business copy!',
  SureDeleteThese: 'Sure delete these',
  OrdersOfBusiness: 'orders of business?',
  SureCancellationAndDeleteCharge: 'Are you sure you want to shut down the business? All fees will be deleted!',
  SureShutOutAndDeleteCharge: 'Are you sure you want to close? All fees will be deleted!',
  CheckingConsignation: 'This business cannot be entrusted. Please check and try again!',
  TheSubBillHasBeenConsolidatedAndCannotBeDelete: 'The sub-bill has been consolidated and cannot be delete.',
  SaveFailedMessage: 'Saving failed. Please refresh and try again!',
  SettlementAgentCannotBeNull: 'Settlement agent cannot be null！',
  SettlementAgentErrorPleaseReSelect: 'Settlement agent error, please re select!',
  NowContainer: 'Current box',
  NowContainerCanNotDelete: 'The current box is occupied and cannot be deleted!',
  NotDelete: 'Cannot delete！',
  PleaseSelectBoxType: 'Please select box type！',
  PleaseEnterUnitPrice: 'Please enter the unit price！',
  PleaseSelectCurrency: 'Please select currency！',
  PleaseEnterTheStartDate: 'Please enter the lease start date！',
  PleaseEnterThebuyDate: 'Please enter the lease buy date！',
  PleaseEnterEndDate: 'Please enter the end date！',
  SuccessfulBoxAdjustment: 'Box transfer succeeded! Processed quantity',
  NoBoxesProcessedSuccessfully: 'No boxes processed successfully,Please check the actual packing!',
  OnlyBuyCaseOrderBoxCanBeSold: 'Only buy case order box can be sold, please check！',
  ChoiceCaseSell: 'Please select the same currency box for sale',
  PleaseContainerData: 'Please enter box information!',
  UnifiedCurrency: 'Box order only supports single currency, please unify box currency!',
  PleaseCheckTheBoxToBeSold: 'Please check the box to be sold！',
  EditedFailMessage: 'Modification failed. Please refresh and try again!',
  DataValidatedWithPartialPass1: 'Data Verified With Warning Continue Or Not',
  DataValidatedWithPartialPass2: 'or Cancel to cancel',
  DataValidatedWithPartialPass3: 'Please click [Cancel] Note: if the verification fails, please process the data items that fail to pass the verification before verification',
  AddChangeCharge: 'Add Change',
  ThereAreNoPayableBillsToPrint: 'There are no payable bills to print.',
  ReleaseInformationNotSelected: 'Release information not selected',
  AreYouSureYouWantTo: 'Are you sure you want to {0} ？',
  NoRecordsAvailable: 'No records available {0}',
  NoDataToAudit: 'No data to audit.',
  NoSplittingRecordSelected: 'No splitting record selected.',
  NoDataToAudit2: 'No data to {0}.',
  EditChangeCharge: 'Edit Change',
  AddSpecialCharge: 'Add Special',
  AddBusinessSpecialCharge: 'Add Business Special',
  EditSpecialCharge: 'Edit Special',
  EditBusinessSpecialCharge: 'Edit Business Special',
  AddSpecialUpdate: 'Special Charge Update',
  Pstsftba: 'Please select the special fee to be adjusted!',
  Nsecbe: 'Non special expense cannot be edited!',
  UpdateWarehouseRecord: 'Do you want to continue saving if the warehouse changes',
  CheckCostAndBusinessMismatching: 'Check Cost And Business Mismatching',
  TicketEntrustedCannotRepetitionDelegate: 'TickEt Entrusted Cannot Repetition Delegate',
  NotFindCurrencyRatePleaseMaintain: 'Not Find Currency {0} Rate Please MainTain',
  BillPaymentDeleteTips: 'Only payment application forms that are not in the status of property approval and unwritten off can be deleted',
  SettlementAgentNotNull: 'Settlement Agent Not Null!',
  PleaseSelectSameSettlementAgent: 'Please Select Same Settlement Agent!',
  TheHAWBAndMAWBAreInconsistentTheSystemWillModifyTheHAWBContinue: 'The HAWB And MAWB Are Inconsistent The System Will Modify The HAWB Continue?',
  AMS_ReturnMessage: 'The gross body information of AMS suitcase is inconsistent with the actual situation, please adjust!\n',
  AMS_ReturnMessageCanSave: 'The gross body information of AMS suitcase is inconsistent with the actual situation. Do you want to continue to save? \n',
  AMS_Quantity: '[AMS number {0} is {1} the actual number of pieces {2}] \n',
  AMS_Weight: '[AMS weight {0} is {1} the actual weight of pieces {2}] \n',
  AMS_Cubage: '[AMS cubage {0} is {1} the actual cubage of pieces {2}] \n',
  AMS_ContainerNo: 'Container No[{0}]：\n',
  CheckPortsByConsignation: 'Your Consignation【{0}】 No Maintenance 【{1}】 Port,Please Check With The Other Party Before Entrusting!',
  CheckPackingByConsignation: 'Your Consignation【{0}】 No Maintenance 【{1}】 Packing,Please Check With The Other Party Before Entrusting!',
  CheckCompanyByConsignation: 'Your Consignation【{0}】 No Maintenance 【{1}】 SCAC Code And Other Relevant Information,Please Check With The Other Party Before Entrusting!',
  CheckCarrier: 'Please Maintain the SCAC code of [{0}], And Then Entrust!',
  SettleAccountMustBeSame: 'Settle Account Must Be The Same',
  ReceivableCannotMorethanPay: 'The Receivable Expenses Cannot Be Greater Than The Payable Expenses',
  PleaseSelectJobs: 'Please Select Jobs',
  SapCommitCheck: 'SAP is one-time presentation has been completed. Please do not repeat the presentation.',
  SapCancelCommitCheck: 'The sap status of the expense cannot be withdrawn. Please confirm the sap status of the expense.',
  escnm: 'Expense settlement department not maintained.',
  SapSynchronizationSuccess: 'Sap Synchronization fee succeeded.',
  SapSynchronizationFault: 'Sap Synchronization fee fault.',
  SapStatusCanNotAudit: 'The sap status of the expense cannot be reviewed. Please confirm the sap status of the expense.',
  ChangeOrderSubmissionFailed: 'Failed to submit the change order. The fee to be modified is not detected.',
  SureYouWantToDeleteFilesTwo: 'Are you sure you want to batch delete these {0} files?',
  JumpFailed: 'Jump failed',
  SelectCopyContent: 'Select copy content',
  CopyContent: 'Copy content',
  SelectImportContent: 'Select import content',
  ImportContent: 'import content',
  DifferenceOverwritesTheOriginalValue: 'Difference overwrites the original value',
  DifferenceRetainsTheOriginalValue: 'Difference retains the original value',
  RememberToChoose: 'Remember to choose',
  TheImportedServiceNumberDoesNotExistProcedure: 'The imported service number does not exist. Procedure',
  TheIDOfTheImportedServiceMustBeDifferentFromThatOfTheImportedService: 'The ID of the imported service must be different from that of the imported service',
  CopyNumber: 'Number of copies',
  QuickSearchBusinessNo: 'Quick search: Business number',
  QuickSearchChineseName: 'Quick search: Chinese Name',
  FinancialDateOfASingleExpense: 'Are you sure you want to modify the financial date of a single expense?',
  ExpenseFinancialDateModifiedSuccessfully: 'Expense financial date modified successfully',
  ModifyTheFinancialDate: 'Are you sure you want to modify the financial date?',
  FinancialDateModifiedSuccessfully: 'Financial date modified successfully',
  ApprovalDateIsEarlierThanBusinessDate: 'The approval date is earlier than the business date. Continue?',
  AreYouSureToReviewTheseLists: 'Do you confirm to review these jobs?',
  ThisBusinessIsNotApproved: 'This business is not in [{0}] status and cannot be approved. Please check!',
  ThisBusinessIsNotApproved2: 'This business is not in [{0}] status and cannot be withdrawn. Please check!',
  TheDocumentChangeSubmission: 'Are you sure you want to withdraw the document change submission?',
  AllowOrderChange: 'Are you sure you want to allow order change?',
  AllowToChangeTheOrderSuccessfully: 'Allow to change the order successfully',
  NoExpenseSelectedOrNotInApprovalStatus: 'No expense selected or not in approval status',
  ExpenseStatusUpdatedSuccessfully: 'Expense status updated successfully',
  BusinessHasGeneratedVouchers: 'The business has generated vouchers,',
  UnableCancelAudit: 'Unable to cancel the audit.',
  BusinessNumberWithGeneratedVouchers: 'Business number with generated vouchers:',
  AreYouSureYouWantToCancelTheApproval: 'Are you sure you want to cancel the approval?',
  LCLTicketsCannotBeReviewedSeparately: 'LCL tickets cannot be reviewed separately. Please review the main ticket.',
  ItIsLocked: 'It is locked and cannot be printed. Please contact your superior supervisor to unlock it!',
  PleaseSelectTheBusiness: 'Please select the business that needs to modify the business date',
  BusinessDateModifiedSuccessfully: 'Business date modified successfully',
  BatchApprovalFailed: 'Batch approval failed',
  PleaseSelectTheBusinessToPrint: 'Please select the business to print',
  NoInTheSelectedData: 'The selected data contains businesses that are not in {0} status and cannot be approved. Please check!',
  TheApprovalDateIsEarlierThanTheBusinessDate: '审核日期小于业务日期,是否继续?',
  FailedToGetDetails: 'Failed to get details',
  PleaseEnterTheBoxSealNumber: 'Please enter the box seal number and print the profit analysis statement.',
  AfterPrintingTheProfitAnalysisStatement: 'After printing the profit analysis statement, this single business will be submitted to the financial audit and cannot be changed Continue?',
  PleaseEnterTheApprovalDate: 'Please enter the approval date',
  PleaseSelectARecordToView: 'Please select a record to view',
  ContractExpireCannotCreated: 'Business cannot be created when the contract of the entrusting company has expired',
  CheckBusinessStatus: 'The operation failed. Please check whether the corresponding business status is normal.',
  CheckCustomsSaved: 'Please save the customs information first！',
  SelectCustomsBroker: 'Select customsBroker.',
  SelectCustomsBrokerPlatFormProvider: '您未在合作伙伴中，给当前所选报关行配置“平台供应商”，不可发送.',
  SelectCustomsSonoLobFiles: '关单号，报关行，报关资料，业务类型不可为空，请核对数据',
  VesselAndvVoyageFlightisEmpty: '船名航次为空，请问是否确定发送',
  customsInfoIsAlredySend: '此报关单已发送过，暂时支持发送一次，如需修改请线下联系对应报关行',
  DocumentEditedTips: 'You are not the document of the ticket and cannot be edited.',
  NotGroupBusinessesCannotBeEdit: 'Businesses that are not in the same group cannot be accessed for editing',
  CustomerTipMessage: '[{0}] not the client, please select again!',
  PortOfLoadingPortCannotBeNull: 'LoadingPort Can\'t be Null!',
  PromissoryNoteIsAFormalBusiness: 'Promissory Note Is A Formal Business!',
  CannotBeConvertedToFormalBusinessInBatch: 'It contains the information that the business source is "own business within the tenant", and cannot be converted to formal business in batch.',
  whetherToTransferSmallTicketToFormalBusinessAtTheSameTime: 'Whether to transfer small ticket to formal business at the same time?',
  transferSmallTicketToFormalJobAtTheSameTime: 'Transfer small ticket to formal business at the same time',
  onlyTheMasterTicketIsTransferredToFormalJob: 'Only the master ticket is transferred to formal business',
  pleaseTransferTheCorrespondingMasterTicketToFormalJobFirst: 'Please transfer the corresponding master ticket to formal business first!',
  BusinessCannotBeOperatedTogether: 'General business and delegated business cannot be operated together, please re select!',
  PleaseEnterTheWarehouseNumber: 'Quick search: Warehousing No',
  BookingSeal: 'Booking Seal',
  CheckSplitCharges: 'The fee has been split. Please delete the split fee first.',
  mutualChargeSynchronizationSuccess: 'Synchronization succeeded !',
  mutualChargeSynchronizationFault: 'Synchronization failed !',
  confirmQuit: 'Are you sure to quit？',
  SelectMBL: 'Please select MBL No.',
  SelectMBLSI: 'Please select MBL No(import operation MBL No).',
  SelectMBLAE: 'Please select MBL No (import operation Basic-MBL No).',
  SelectMBLAI: 'Please select MBL No (Air transport operations MBL No).',
  SelectLob: 'Select Lob',
  SelectPreCustomsDate: 'Select PreCustomsDate',
  SelectHarborDistrictSe: 'District(Booking tab - port area)cannot be null',
  SelectHarborDistrictSi: 'District(进口操作-港区)cannot be null',
  DestinationPlaceNotNull: 'Place of delivery (import operation - place of delivery) cannot be null',
  AirportPortNotNull: 'Airport port cannot be empty',
  ExpectedDateOfArrivalNotNull: 'Expected arrival date (import operation expected arrival date) cannot be null',
  SelectCustomsFiles: 'Select Customs Files',
  CustomsHasBeanSend: 'This customs declaration has been sent. It can be sent once. If you need to modify it, please contact the corresponding customs broker',
  FileSizeExceeds4MBYouCannotUploadPleaseSendEmailSe: 'file size exceeds 4MB, you cannot upload. Please send email to xh08@thecustoms.com.cn',
  PleaseUploadFileSeaExport: 'Please upload such documents as customs declaration power of trust, shipping information, export declaration form, draft form, commodity declaration factor invoice, packing list, etc',
  PleaseUploadFileSeaImport: 'Please upload the customs declaration letter of entrustment FCL bill of lading information or copy of invoice packing list contract certificate of origin commodity declaration elements',
  PleaseUploadFileAirExport: 'Please upload the customs declaration power of attorney, shipping bill, export customs declaration draft and other documents',
  PleaseUploadFileAirImport: 'Please upload such documents as customs declaration, power of attorney, notice of arrival, air waybill, invoice, packing list, contract certificate of origin, commodity declaration elements, etc',
  SuccessfulCustoms: 'Successful customs declaration!',
  FaildCustoms: 'Customs declaration request failed, please contact the administrator!',
  AsyncReceivableChargesToImportJob: 'All receivable expenses will be synchronized to the import business. Are you sure you want to continue?',
  AsyncPayableChargesToImportJob: 'All payable expenses will be synchronized to the import business. Are you sure you want to continue?',
  escnm2: 'Expense settlement department not maintained.',
  SelectMoreTwoRow: 'Please select at least two pieces of data to combine!',
  OnlySplitMasterJob: 'Only the master ticket can be split!',
  SplitJobTip: 'Please check the main ticket with buyer console FCL type, and split the main ticket with business status of positive operation!',
  CombinationJobSelectMasterTip: 'Are you sure to combine the following businesses? Please select one salesman as the primary ticket?',
  CombinationJobForFcl: 'The whole splicing type is full container and buyer console FCL',
  CombinationJobForJobState: 'The business status is positive operation status',
  CombinationJobForCustomer: 'Consistent with the entrusting unit',
  CombinationJobForVessel: 'The name of the ship is the same',
  CombinationJobForVesselVoyage: 'Consistent voyage',
  CombinationJobForMaster: 'Please select master ticket!',
  CombinationJobTip: 'Please select the business of {0} to operate!',
  ValidateCombinationJobTip: 'The business with bill of lading No. {0} has been used. Please click Cancel to perform the combination operation again!',
  OnlyJoinForCombinationJob: 'Only full container and buyer console FCL businesses can be added!',
  TheTitleOfTheInvoiceIsInconsistentDoYouWantToContinue: 'The title of the invoice is inconsistent. Do you want to continue?',
  TheSubBillsAndMBLAreInconsistentTheSystemWillModifyTheSubBillsContinue2: 'The ship name, voyage, carrier, booking agent, destination agent, ETD, ETA, warehouse information and shipping company appointment number of the newly selected small ticket are inconsistent with the main ticket. The system will modify the small ticket. Continue?',
  HblNoMoreThanTwelve: 'The sub document number cannot exceed 12 digits!',
  WriteOffPushSuccess: 'Record push verification succeeded!',
  WriteOffPushError: 'Failed to cancel record push!',
  CancelConfirmBill: 'Cancel expense confirmation status synchronously?',
  AreYouSureYouWantToDeleteTheSelectedFee: 'Are you sure you want to delete the selected fee?',
  JobOfClosingAccountTip: 'Business date cannot be saved, please adjust and save!',
  ThePacketHasBeenSentAndWhetherToImportItAgain: 'The packet has been sent and whether to import it again?',
  PleaseCheckAtLeastOnePieceOfData: 'Please check at least one piece of data',
  NoHasViewRole: 'No viewing permission, please contact the administrator for configuration!',
  NoHasViewBillingRole: 'You do not have permission to view the bill, please contact the administrator for configuration!',
  NoHasViewBillingGroupRole: 'You do not have permission to view the statement. Please contact the administrator for configuration!',
  checkSpecialChargeTips: 'Voucher cannot be generated if there are special expenses in the write off record, please select again!',
  CheckCustomJobTypeTips: 'Please select a custom business type before saving!',
  AMSCodeCannotBeNull: 'Base Config AMSCompanyCodeNullNotAllowed!',
  MblNoIsOverLength: '【MB/L NO】Field exceeds 16 bits.',
  AmsNoIsOverLength: '【AMS NO】Field exceeds 12 bits.',
  IsOverLengthTip: '{0} characters are too long, please do not exceed {1} characters per line of data.',
  UnitTypeNotNull: 'Unit Type cannot be empty, please enter',
  Shipper: 'Shipper',
  Consignee: 'Consignee',
  Notify: 'Notify party',
  SecondNotify: 'Second Notify',
  SpecialCharacter: 'The {0} field contains illegal characters, unable to save!',
  TipsOnAutoSplittingCharge: 'Please enter the tax inclusive price of the split expense!',
  DeleteSmallTicketTips: 'You do not have permission to delete the ticket!',
  SyncToSmallTicketSuccessTips: '{0} node status has been synchronized to small ticket!',
  OperationTypeInUsed: '{0}{1}already has {2} transportation terms displayed by default, please select again!',
  StartUpdatingTheBasicData: 'Start updating the basic data',
  BasicDataUpdateSuccessfully: 'Basic data update successfully',
  BatchSubmitCheck: 'You can only submit orders that are in operation or pre-submitted in batches!',
  isExistHBLANDMBLTips: 'The splitting number under a primary doc No. cannot be repeated. Please re-enter the splitting number!',
  operateTypeUpdateTips: 'Operation mode change, whether to update MAWB transceiver information?',
  SettlingAgentInconsistent: 'The settlement agent is inconsistent. Continue?',
  SettlingAgentInvoiceTitleInconsistent: 'The settlement agent and billing header are inconsistent. Do you want to continue?',
  ChargeEmpty: 'Charge Empty !',
  NoChargeForTheSettlementOfPrint: 'There is no expense settlement object matching the printing conditions',
  PleaseEnterTheCreationDate: 'Please enter the creation date.',
  SelectDate: 'Select date',
  DefaultCurrency: 'Default currency',
  EDISUBMISSIONCenter: 'EDI SUBMISSION Center',
  EDICenter: 'EDI center',
  MessagePreview: 'Message preview',
  MessageDesign: 'Message design',
  ReceiverCodeCannotBeEmpty: 'Receiver code cannot be empty',
  SelectEDIType: 'Select EDI type',
  NotConfigured: 'not configured',
  SelectSendingChannel: 'Select sending channel',
  SelectFileNature: 'Select File nature',
  SelectFileTemplate: 'Select file template',
  SelectedBusiness: 'Selected business:',
  BackToEDICenter: 'Back to EDI center',
  Design: 'Design',
  SendAll: 'Send all',
  Tips: 'Tips:',
  UsedInTemplateDesign: 'Used in template design',
  Check: 'Check',
  SentSuccessfully: 'Sent successfully!!',
  TemplateSavedSuccessfully: 'Template saved successfully',
  OtherDocuments: 'Other documents',
  ClickUpload: 'Click upload',
  UnsupportedFileType: 'Unsupported file type',
  TheSizeExceedsTheLimit: 'The file size exceeds the limit',
  UploadFailed2: 'Upload failed',
  PleaseSelectABusinessNumber: 'Please select a business number',
  TheExceeds20MBAndUploaded: 'The volume of one file exceeds 20MB and cannot be uploaded',
  UploadPleaseContactTheAdministrator: 'Upload failed, please contact the administrator.',
  FailedPleaseRefreshAndAgain: 'Failed to get data. Please refresh and try again',
  ExternalImportedDataNonEditable: 'External imported data, non editable',
  ExternalDataCannotBeDeleted: 'External imported data, cannot be deleted.',
  RequestSucceededExporting: 'Request succeeded, exporting!',
  Main: 'main',
  PleaseEnterTheWarehousingNumber: 'Please enter the warehousing number!',
  PleaseEnterTheWarehouseName: 'Please enter the warehouse name!',
  PleaseEnterTheWarehouseInDate: 'Please select the warehouse in date!',
  PleaseMaintainWeighDetail: 'Please maintain the weighed (actual) cargo details first!',
  PleaseEnterComments: 'If the verification result is not approved, please fill in the processing comments!',
  PleaseSelectTheClosingWeight: 'Please select the closing weight!',
  SureToSaveLabeling: 'Have not weighed yet, please confirm whether to save the labeling information?',
  PleaseLengthWidthPieces: 'Please enter the size in the correct format: length * width * height * number of pieces!',
  PleaseTheNumberOfPieces: 'Please enter the number of pieces!',
  WarehouseNumberAlreadyExistsContinue: 'Warehouse entry number already exists, continue',
  SavedSuccessfully: 'Saved successfully!',
  ChecklistSuccessfully: 'Checklist status update successfully!',
  NoSynchronizationContent: 'No synchronization content',
  ThereSynchronizationSpecialGoodsSynchronize: 'There are cases associated with special goods in the packing information. After synchronization, special goods need to be re associated. Are you sure to synchronize?',
  SynchronizationSucceeded: 'Synchronization succeeded',
  SynchronizationFail: 'Synchronization fail',
  ThisJobIsNotWorkingCanNotBeEdited2: 'The specified service is not in a positive operation state and cannot be synchronized',
  ASameBoxTypeExists: 'A record of the same box type already exists!',
  IfToRefreshTheContainers: 'If the container quantity has been changed, do you want to refresh the original charge based on the number of containers?',
  BusinessCannotBeEmpty: 'Business cannot be empty!',
  ViewChargebackFile: 'View chargeback file',
  SelectDepartment: 'Select Department',
  PleaseSelectADepartment: 'Please select a department!',
  ReceiptSucceeded: 'Receipt succeeded',
  ReceiptError: 'Receipt error',
  SubmittedForDeletion: 'Submitted for deletion',
  ModificationFailed: 'Modification failed',
  EDIStatusChangeRecord: 'EDI status change record',
  FeedbackNode: 'Feedback node',
  YouTheLinkAddressDirectly: 'You can copy the link address directly',
  HistoricalAnomaly: 'Historical anomaly',
  TimeOfOccurrence: 'Time of occurrence',
  VerificationOfEstimatedProfitMargin: 'Verification of estimated profit margin',
  EstimatedIncome: 'Estimated income',
  EquivalentToRMB: 'Equivalent to RMB',
  EstimatedCost: 'Estimated cost',
  EstimatedProfit: 'Estimated profit:',
  EstimatedProfitMargin: 'Estimated profit margin:',
  EstimatedRemarks: 'Estimated remarks:',
  EstimatedMustBeFilledIn: 'Estimated remarks must be filled in',
  Sunday: 'Sunday',
  Monday: 'Monday',
  Tuesday: 'Tuesday',
  Wednesday: 'Wednesday',
  Thursday: 'Thursday',
  Friday: 'Friday',
  Saturday: 'Saturday',
  SelectFileType: 'Select file type',
  FileInformation: 'file information',
  Thumbnail: 'thumbnail',
  DownloadPhotos: 'Download photos',
  UploadComplete: 'Upload complete!',
  UploadFailedSigh: 'Upload failed!',
  HelloNNPleaseCheck: 'Hello, \ n \ nPlease check',
  WarehousingNo: 'Warehousing No-',
  WarehousingNoColon: 'Warehousing No.:',
  PhotosNthankYouN: 'Photos of \ n \ nthank you \ n \ n',
  SendingSucceeded: 'Sending succeeded!',
  SendingFailed: 'Sending failed!',
  PleaseTheFileToDownload: 'Please select the file to download',
  WaybillNo: 'Waybill No.:',
  ConfirmSending: 'Confirm sending',
  ReturnToModify: 'Return to modify',
  ChannelName: 'Channel name',
  PleaseSelectASendingChannel: 'Please select a sending channel!',
  FailedToGetTemplate: 'Failed to get template',
  TheDocumentOfTheContinue: 'The name of the ship, voyage, shipping company, main document number, document replacement agent, sailing date, expected arrival date, actual arrival date, warehouse, delivery method of main document and freight terms of main document of the newly selected small ticket are inconsistent with those of main ticket; Or the customs sub order number of small ticket is blank. \\ R \ nthe system will modify the ticket. Continue?',
  PleaseSelectACodingRule: 'Please select a coding rule',
  ApplicationForRelease: 'Application for release',
  ApplyForShipperCode: 'Apply for shipper code',
  NoDataSelected: 'No data selected!',
  InvalidFee: 'Invalid fee!',
  ReceivingMethod: 'Receiving method:',
  CellPhoneNumber: 'cell-phone number:',
  NoteDoesNotAffectPartner: 'Note: the information modified on this page does not affect the original configuration of the partner',
  emptySopNodeWarning: 'If the push node is empty, the message will not be pushed correctly.',
  AsynchronousLocking: 'Asynchronous locking is in progress in the background. You can check the results in the upper right corner (message) later',
  AsynchronousJobAccountVerify: 'Asynchronous processing is in progress in the background. You can check the results in the upper right corner (message) later',
  RepeatClick: 'The order locking operation is in progress in the background. Please do not click repeatedly',
  RepeatClickJobAccountVerify: 'The background is performing audit operation, please do not click repeatedly',
  RepeatClickJobAccountVerify2: 'The background is canceling the audit. Please do not click again',
  AddFromPartner: 'Add from partner',
  AddManually: 'Add manually',
  ReceivingMode: 'Receiving mode',
  PushNodeCannotBeEmpty: 'Push node cannot be empty!',
  PushBeEmptyPleaseCheck: 'Push node cannot be empty, please check:',
  DetailedNumberOfCheckedGoods: 'Detailed number of checked goods',
  NumberAssociatedPackingInformationPieces: 'Number of associated packing information pieces',
  DetailedWeightOfGoodsChecked: 'Detailed weight of goods checked',
  AssociatedPackingInformationWeight: 'Associated packing information weight',
  DetailedVolumeOfGoodsChecked: 'Detailed volume of goods checked',
  AssociatedPackingInformationVolume: 'Associated packing information volume',
  CopyShippingMarkAndName: 'Copy from the entrusted shipping mark and product name',
  OperationCategory: 'Operation category',
  PleaseEnterTheBusinessNumber: 'Please enter the business number',
  NonExistent: 'non-existent.',
  ContainerTip: 'This box has been associated with expenses. Please cancel the association before modifying the box number',
  UploadCustomsDeclarationFile: 'Upload customs declaration file',
  UploadChargebackFile: 'Upload chargeback file',
  RevenueTypeCannotBeBlank: 'Revenue expense type cannot be blank!',
  SettlementCompanyCannotBeBlank: 'Settlement company cannot be blank!',
  IncorrectFormatOnlyIntegerSupported: 'Incorrect tax rate data format, only integer is supported!',
  domesticForeignCannotBeEmpty: '[domestic and foreign] cannot be empty!',
  ImportResults: 'Import results',
  AllSuccess: 'All success',
  AllFailed: 'All failed',
  PartialFailurePartialSuccess: 'Partial failure, partial success',
  OddNumbers: 'Odd Numbers',
  PleaseTheSameBusinessOperate: 'Please select a business of the same business type to operate!',
  OperationError: 'Operation error',
  NewBusiness: 'New business',
  ThePleaseRefreshAndAgain: 'The system is busy, please refresh and try again',
  SubmittersRemarks: 'Submitter\'s remarks',
  PleaseFillInTheRemarks: 'Please fill in the remarks',
  YouAreNotTheSubmitter: 'You cannot operate this business if you are not the superior supervisor of the submitter!',
  PleaseFillInTheRemarksSigh: 'Please fill in the remarks!',
  PleaseEnterRemarks: 'Please enter remarks!',
  TheTheCurrentOperationMaintenance: 'The superior supervisor is not maintained in the current operation. Please submit this business after maintenance!',
  FailedForApprovalPleaseAgain: 'Failed to submit to supervisor for approval, please refresh and try again!',
  SubmittedSupervisorForApprovalSuccessfully: 'Submitted to supervisor for approval successfully',
  ApprovedPass: 'Approved!',
  ApprovalRejected: 'Approval rejected!',
  Problem: 'problem',
  Synchronized: 'Synchronized',
  NotSynchronized: 'Not synchronized',
  YouToEditTheAdministrator: 'You do not have the corresponding permission to edit the data, please contact the administrator',
  SentOut: 'Sent out!',
  DefaultPSettlementID: 'Default fixed a / P settlement object ID',
  IsAREmpty: 'Is the default a / R object empty',
  IsAPEmpty: 'Is the default a / P object empty',
  TheFormCannotBeEmpty: 'The customs declaration form cannot be empty!',
  ReminderOfTheCustomsData: 'Reminder: Please click OK to save the required information of the customs declaration before uploading the customs declaration data',
  ReminderOfTheCustomsPrint: 'Reminder：The following data will not be pushed to the customs broker and will only be used for printing document data sources',
  ObtainActualBusinessData: 'Obtain actual business data',
  TheToBeViewedAnyone: 'The file is not allowed to be viewed or downloaded by anyone',
  YouPermissionToViewDownload: 'You do not have permission to view or download',
  File: 'file',
  PleaseInTheSubmissionNotes: 'Please fill in the submission notes',
  ContainsInvoicesThatCannotBeModified: 'Contains invoices that cannot be modified',
  RemarksReviewedBy: 'Remarks reviewed by',
  numberingRuleCannotBeEmpty: '[numbering rule] cannot be empty!',
  PortAreaDataComparison: 'Port area data comparison',
  ImportMode: 'Import mode',
  Keep: 'keep',
  Explain: 'explain:',
  BlackIsTheInputData: 'Black is the input data,',
  BlueThePortAreaData: 'Blue is the port area data,',
  GrayIsPreEnteredData: 'Gray is pre entered data',
  UpdatedToPortAreaData: 'Updated to port area data',
  lclCompareHarbourTips1: '1. The default is all overwritten ("port data" all covers "system entry" data), unchecked box means that system data is retained, and port data is not covered; Uncheck all to keep the original system data',
  lclCompareHarbourTips2: '2.Red indicates information that compares "system data" with "port data"',
  lclCompareHarbourTips3: 'Please confirm the correct packing information as soon as possible, it will affect the subsequent SOP and container warning information push display',
  UpdatedData: 'Updated data',
  compareHarbourTips1: '1. Default full coverage (all data in the port area covers data entered by the system)',
  compareHarbourTips2: '2. Click the box number to switch to view the information, and the red color indicates the information that is inconsistent with the "system data" and "port data"',
  compareHarbourTips3: '3.If unchecked in \'Other\', \'System Data\' will be removed from the packing information, and \'Port Area Data\' will not add packing information; If unchecked in the corresponding box number, the \'system data\' will be retained; Uncheck all options to retain the original system data',
  compareHarbourTips4: 'Please confirm the correct packing information as soon as possible, as it will affect the subsequent SOP and push display of box cargo warning information',
  SystemEntry: 'System entry',
  PortAreaData: 'Port area data',
  ImportDescriptions: 'The import type is Modified, and the system matches the data consistent with the port area according to the box number,\nbox type, and box type. The import type is New, because the system did not find data that is consistent with the port area data.\n The import type is Maintain, and the data entered for you does not match the data in the port area, that is, the data entered for you is the original data.',
  WhenTheBoxIsIdentifiedAsABox: 'When the box is identified as a box, the customs order number is not displayed, and the data of the piece hair is the total of the goods.',
  ClickEnteredDataPleaseOperation: 'Click [Update to Port Data], the system will update the system input data as port data according to the selected information, and the font color will become black, please confirm that the port area data is correct before operating.',
  Determine: 'determine',
  Cancel2: 'Cancel',
  PleaseAtLeastOneRecord: 'Please select at least one record!',
  Hello: 'Hello!',
  EnclosedPleaseFind: 'Enclosed please find',
  PhotosOf: 'Photos of',
  ThankYou: 'thank you',
  TheAndFreightTermsBlank: 'The name of the ship, voyage, shipping company, main document number, document replacement agent, sailing date, expected arrival date, actual arrival date, warehouse, delivery method of main document and freight terms of main document of the newly selected small ticket are inconsistent with those of main ticket; Or the customs sub order number of small ticket is blank.',
  TheModifyTheSmallContinue: 'The system will modify the small ticket. Continue?',
  SaveFailedSigh: 'Save failed!',
  CellPhoneNumber2: 'cell-phone number',
  NoSopNodeMatched: 'The node of the current business is not matched, please select again.',
  NameCannotBeEmpty: 'Name cannot be empty!',
  PleaseSelectARecord2: 'Please select a record',
  ChangePassword: 'Change Password',
  OriginalPassword: 'Original password',
  NewPassword: 'New password',
  ConfirmPassword: 'Confirm password',
  ModificationPleaseLogInAgain: 'Modification succeeded. Please log in again',
  TheEnteredTwiceAreInconsistent: 'The passwords entered twice are inconsistent',
  DearUser: 'Dear user:',
  ItSystemInOrderMode: 'It is detected that your current browser mode is compatible mode, which will affect the running speed of cargoware system. In order to improve the running speed and operation efficiency of the system, please switch to extreme speed mode.',
  TheShownInTheBelow: 'The specific operation is shown in the figure below:',
  ToSwitchTutorialsSee: 'To switch tutorials, see:',
  GotIt: 'got it',
  FullScreen: 'Full screen',
  EarlyWarningReminder: 'Early warning reminder',
  AnnouncementMessage: 'Announcement message',
  Cancellation: 'cancellation',
  FlagshipEdition: 'Flagship Edition',
  BasicEdition: 'Basic Edition',
  TrialCustomers: 'Trial customers',
  FormalCustomer: 'Formal customer',
  SystemAdministrator: 'system administrator',
  RefreshCacheMethod: 'Refresh cache method',
  AfterTheCorrespondingCacheData: 'After maintaining the master data, please update the corresponding cache to obtain the latest data.',
  ViewCacheRefreshMethod: 'View cache refresh method',
  PleaseExitTheEditingModule: 'Please save the changed data first, or exit the editing state, and then close the module.',
  SessionPleaseLogInAgain: 'Session timeout, please log in again',
  EDITemplateExceptionDownloadFailed: 'EDI template exception, download failed',
  One: 'one',
  Two: 'two',
  Three: 'three',
  Four: 'four',
  Five: 'five',
  Six: 'six',
  Just: 'just',
  MinutesAgo: 'Minutes ago',
  HoursAgo: 'Hours ago',
  OneDayAgo: '1 day ago',
  LastWeek: 'Last week',
  LastMonth: 'Last month',
  LastThreeMonths: 'Last three months',
  PleaseSelectDataFirst: 'Please select data first',
  SelfBooking: 'Self Booking',
  CommissionedBooking: 'Commissioned Booking',
  CustomerSelfBooking: 'Customer self Booking',
  OwnContractPrice: 'Own contract price',
  CustomerOffer: 'Customer offer',
  OverseasAgentContractPrice: 'Overseas agent contract price',
  UncommittedPrice: 'Uncommitted price',
  BuyerLCL: 'Buyer LCL',
  InnerPacking: 'Inner packing,',
  DoorPointPacking: 'Door point packing,',
  SelfPullingAndSelfSending: 'Self pulling and self sending,',
  DeclareAtCustoms: 'declare at customs,',
  Fumigation: 'Fumigation,',
  CommodityInspection: 'Commodity inspection,',
  BookingSpace: 'Booking space,',
  SetSpell: 'Set spell',
  PersonalBelongings: 'Personal belongings',
  OneMasterAndManyPoints: 'One master and many points',
  OneMasterAndOneMinute: 'One master and one minute',
  UnknownType: 'Unknown type',
  Marked: 'Marked',
  Unmark: 'unmark',
  PendingOrder: 'Pending order',
  OrderPlaced: 'Order placed',
  ReceivedOrder: 'Received order',
  NotIssued: 'Not issued',
  Issued: 'Issued',
  Retrieved: 'Retrieved',
  Accepted: 'accepted',
  Claimed: 'Claimed',
  ChangeOrder: 'Change Order',
  ApprovedBusinessCannotBeEdited: 'Approved business cannot be edited',
  OrderAlreadyApproved: 'Order {0} has been approved.',
  YouPermissionToEditNotes: 'You do not have permission to edit promissory notes',
  EnglishNameOfHBLConsignee: 'English name of HBL consignee',
  EnglishNameOfHBLShipper: 'English name of HBL shipper',
  AgentNetworkCustomerService: 'Agent network customer service',
  ReImportAfterModification: 'Re import after modification',
  DownloadFailedData: 'Download failed data',
  TheCaseOfMultipleFirst: 'The extended period is not recommended to be used in the case of multiple choices. Please check whether there is a redundant tick first!',
  InvalidNumberEntered: 'Invalid number entered!',
  TheOrThePartnerSigned: 'The customer has signed or the partner has been signed!',
  FirstDateCannotBeBlank: 'First contact date cannot be blank!',
  PleaseInTheTelephoneNumber: 'Please fill in the telephone number!',
  PleaseRemoveTheTicketFirst: 'Please remove the ticket first',
  ExpenseHasBeenEntered: 'Expense has been entered',
  ConsolidationHasBeenDone: 'Consolidation has been done',
  Save: 'Save?',
  PleaseEnterCurrencyExchangeRate: 'Please enter currency exchange rate',
  FailedOpenSalesQueryDetails: 'Failed to open sales query details!',
  pleaseEnterTemplateName: 'Please enter the template name',
  blank: 'Blank',
  PartnersBeenAddedToBlacklist: 'Partners have been added to the blacklist!',
  ThisCustomerRiskyCustomerOperateOrdersWithCaution: 'This customer is a risky customer. Please {0} orders with caution',
  AlreadyExistsOverwriteOriginalScheme: 'The scheme name already exists. Do you want to overwrite the original scheme?',
  NoDataToSave: 'No data to save',
  ColumnSettings: 'Column settings',
  CurrentPage: 'Current page',
  CurrentSelection: 'Current selection',
  NoModificationAllowedAfterBusinessSubmission: 'No modification is allowed after business submission. Please confirm whether relevant documents have been uploaded before submission',
  AboutToUploadFiles: 'About to upload files',
  SuccessfullyUploaded: 'Successfully uploaded',
  RetrievalOfAssignedPermissions: 'Retrieval of assigned permissions',
  UploadResults: 'Upload results',
  OnlyFilesFormatCanUploaded: 'Only files in the format {0} can be uploaded',
  VolumeAbnormalAndCannotUploaded: 'The file volume is abnormal and cannot be uploaded',
  VolumeExceeds5mAndCannotUploaded: 'The file volume exceeds 5m and cannot be uploaded',
  VolumeExceeds20mAndCannotUploaded: 'The file volume exceeds 20m and cannot be uploaded',
  PlaceOfDeliverySeaport: 'Place of delivery (seaport)',
  PlaceOfDeliveryAirport: 'Place of delivery (Airport)',
  SailingDay: 'Sailing Day',
  BusinessCreationDate: 'Business creation date',
  DeliveryStation: 'delivery station',
  NoDocumentsDeclaringOrNonSpermWhaleUsers: 'No documents found, may be declaring or non sperm whale users.',
  HasContainerNoOrSealNoForSameEqTypeAndEqSize: 'This box type has been associated with packing information. Do you want to change the packing information tab box type synchronously?',
  SeaEqAsyncToContainerTip: 'Relevant packing information has been entered. Please delete the packing information in the packing information tab first!',
  TheSynchronizedFileCannotBeEdited: 'The synchronized file cannot be edited',
  TheSynchronizedFileIsNotDeleted: 'The synchronized file is not deleted',
  CurrentBusinessStatusCannotBeSynchronized: 'Current business status cannot be synchronized',
  TheSynchronizedExpensesCannotBeDeleted: 'The synchronized charge cannot be deleted. Please cancel the expense synchronization first.',
  ChargeSyncConfirmTip: 'The current charge sync operation is irreversible. Are you sure to continue?',
  ChargeAlreadySynced: 'Charge already synced, cannot sync again',
  CurrentlyThereIsNoSynchronizationCosts: 'Currently there is no synchronization costs',
  ThereAreCurrentlyNoCancellableCharges: 'There are currently no cancellable charges',
  NoCurrentChargesCanBeCancelled: 'No current charges can be cancelled',
  ChargeItemChangeTip: 'The default settlement information of this expense name is inconsistent with the current expense. Do you want to update it?',
  SubscriptionInformation: 'Set the (Branch) company you want to receive subscription information',
  SetUpThePartners: 'Set up the partners you need to subscribe to',
  PleaseSelectAInformation: 'Please select a freight rate information.',
  ThisRateHasExpired: 'This rate has expired!',
  ExternalUsersCannotEdit: 'External users cannot edit. Please go to the partner e-commerce user tab.',
  CommunicationConfirmation: 'The sailing date that meets the shipping schedule requirements cannot be found within the validity of the freight rate. Please communicate with the booking party for confirmation!',
  CombineTips: 'You cannot select the main ticket to combine.',
  RepeatMblForSave: 'Duplicate primary doc No., are you sure to save?',
  SystemAlert: 'System alert',
  NotRepeatOperation: 'The status has changed, please do not repeat the operation.',
  FeesHaveBeenUsedForEditUnit: 'The company code has been used by the expense and cannot be modified!',
  TheChargingUnitIsUsedByAnExistingChargePlanForEditUnit: 'This billing unit code is used by the existing fee scheme and cannot be modified!',
  ApplyChangeChargeNotThrough: '{0}, cannot {1}, please reselect.',
  KingdeeNotExist: 'The data need not be synchronized or the Kingdee system does not exist',
  ByAdjustmentDate: 'By adjustment date',
  ByBusinessDate: 'By business date',
  PleaseEnterTheFileType: 'Please enter the file type',
  NotExportToImportBusiness: 'This document is not an export to import business and cannot be synchronized!',
  JobNotOperateStatus: 'This order is not in active operation status and cannot be synchronized!',
  JobShutOut: 'This order has been returned and cannot be synchronized!',
  ChargeSyncSuccess: 'Fee synchronization succeeded!',
  NoSynchronizedFees: 'There are no synchronized fees!',
  SaveColumnSettingsSameTime: 'Save the current display column settings at the same time',
  SaveScheme: 'Save sheme',
  ReceivableCharge: 'Receivable(charge)',
  PayableCharge: 'Payable(charge)',
  TruckingNotExist: 'Packing information does not exist!',
  SaveDisplayColumns: 'Save Display Columns',
  NoPermissionToAddExpense: 'No permission to add expense',
  NoPayableAddPermissionCannotImported: 'You have no permission to add payable expenses, and no expenses can be imported',
  NoPayableAddPermissionOnlyImportReceivable: 'You have no permission to add payable expenses, and only import receivable expenses',
  NoReceivableAddPermissionCannotImported: 'You have no permission to add receivable expenses, and no expenses can be imported',
  NoReceivableAddPermissionOnlyImportPayable: 'You have no permission to add receivable expenses, and only import payable expenses',
  OnlyRejectedBusinessesCanDelete: 'Only rejected businesses can be deleted',
  OnlyRejectedBusinessesCanDeleteIgnoreOther: 'Only rejected businesses can be deleted, other businesses have been ignored',
  SuccessfullySubmittedXBusiness: 'Successfully submitted {num} business',
  SuccessfullySubmittedXBusinessOtherIgnore: 'Successfully submitted {num} business, the prequalification status of other businesses does not meet the submission conditions',
  SuccessfullyRevokedXBusiness: 'Successfully revoked {num} business',
  SuccessfullyRevokedXBusinessOtherIgnore: 'Successfully revoked {num} business, the prequalification status of other businesses does not meet the revoke conditions',
  SuccessfullyConvertRealXBusiness: 'Successfully transfer to formal {num} business',
  SuccessfullyConvertRealXBusinessOtherIgnore: 'Successfully transfer to formal {num} business, the prequalification status of other businesses does not meet the transfer to formal conditions',
  ChargeSyncJobStateCheckFail: 'Expense synchronization business status verification failed',
  HaveChargeNotAllocatedAndtoContinue: 'There are expenses that have not been allocated. Are you sure you want to continue expense synchronization?',
  PartnerAlreadyExistPleaseSelectOfficialCustomer: 'Partner already exists, please select from official customers',
  PartnerHasMaintainedUndeToContinue: 'This partner has been maintained under [{officeCode}], do you want to continue to create it?',
  fileManagement: 'File management',
  FilterValue: 'Filter value',
  PriceAndNumIsNull: 'Unit price and quantity are blank. Continue?',
  SyncContainerSealNoToBillOfLading: 'Synchronously update the packing information box seal number of the bill of lading',
  AssociatedBillOfLadingCannotDelete: 'Associated bill of lading, cannot be deleted',
  AssociatedBillOfLadingCannotRemove: 'Associated bill of lading, cannot be removed',
  SettlementObjectAccountPeriod: 'Accounting period of settlement object',
  SettlementObjectAccountCredit: 'Credit control limit for settlement objects',
  InvoiceHeaderDifferent: 'Invoice headers are different, Continue?',
  Agreement: 'Agreement',
  NotAgreement: 'Not agreement',
  AllocationNature: 'Allocation nature',
  VirtualAllocation: 'Virtual allocation',
  ActualSplit: 'Actual split',
  ShareTypeTip: 'Same: The allocation type of all expenses is consistent. Modify the allocation type of one expense, and change all other expenses to be consistent\nNot Same: The allocation type of expenses can be different. When changing the allocation type, only the allocation type of the current expense can be changed',
  VirtualAllocationAndActualSplitTip: 'Virtual allocation: Perform billing, invoicing, payment application, write-off and other settlements in the main document.The expenses allocated to small bills are virtual and can only be viewed without substantive settlement.\nActual Split: Allocated expenses are settled in document splitting, such as billing, invoicing, payment application, and write-off.If the expense of the main document has been settled, the expense cannot be split into small bills',
  ActualSplitWarn: 'Note: After the actual split, the original cost of the main order will not be retained and cannot be restored. Please operate with caution!',
  CannotActualSplitTip: 'You cannot split expenses into small bills after settlement actions such as expense account creation, invoicing, payment application, and write-off of the main document!',
  SharedChargeTotal: 'Total amount of shared expenses',
  DataHadUpdated: 'The data has been modified. Please query and try again',
  OpenSOPPanelNeedDoubleClick: 'To open the SOP panel, double-click the business status to call up again.',
  Operator: 'Operator',
  HaveInHand: 'have in hand',
  Exception: 'Exception',
  TerminalCompany: 'Terminal company',
  TerminalLocation: 'Terminal Location',
  DeliveryAddress: 'Delivery address',
  TerminalAddress: 'Terminal Address',
  TcDeliveryAddress: 'Terminal company delivery address info',
  ResultLogUploadFaild: 'Result log upload to cloud storage failed, please try again!',
  ConfigureDisplayColumns: 'Configure Display Columns',
  AllNames: 'All Names',
  SelectedColumns: 'Selected columns',
  NoPermissionViewSecondaryTable: 'You do not have permission to view secondary table information!',
  NoPermissionSetSecondaryTableColumns: 'You do not have permission to set secondary table display columns!',
  UpdateNoticeDetails: 'Update Notification 【Details】',
  DontRemindMeAgain: 'Don\'t inform me next time',
  NewInnerContractNo: 'New inner contract no',
  EditInnerContractNo: 'Edit inner contract no',
  AreYouSureToCancelThisData: 'Are you sure to cancel this data?',
  HasBeenUsedAndCannotEditContractNo: 'Has been used and cannot edit contract no',
  HasBeenUsedAndCannotBeDeleted: 'Has been used and cannot be deleted',
  ApplicableRoute: 'Applicable route',
  IsEnable: 'Is enable',
  ContractNoUseState: 'Contract no use state',
  NotUse: 'Not use',
  Occupies: 'Occupies',
  DataLoadingFailed: 'Data loading failed...',
  ExportExcel: 'Export Excel',
  ExportExcel2: 'Export EXCEL',
  ExportWord: 'Export WORD',
  ExportPDF: 'Export PDF',
  ExportPPT: 'Export PPT',
  NoDataIsCurrentlySelected: 'No data is currently selected',
  SelectAll: 'Select all',
  CustomerSelfIssue: 'Customer self-issue',
  Clear: 'Clear',
  QuickOfLadingNumberCustomsNumber: 'Quick search: Business number/Bill of lading number/Customs declaration number',
  QuickMnemonicabbreviationChineseAndEnglishNames: 'Quick search: mnemonic/abbreviation/Chinese and English names',
  InvoiceNumber: '/Invoice number',
  BusinessNumber: '/Business number',
  BillingNumber: '/Billing number',
  PaymentApplicationNumber: '/Payment application number',
  VerificationNumber: '/Verification number',
  ReconciliationNumber: '/Reconciliation number',
  ActualPaymentAndReceiptNumber: '/Actual payment and receipt number',
  DeliveryOrderNumber: '/Delivery order number',
  ProgramNumber: '/Program number',
  QuickSearch: 'Quick search',
  SearchBeRemovedNotFound: 'Search item to be removed not found',
  Error3: 'Error',
  AdvancedSchemeLoadingFailed01: 'Advanced query configuration scheme loading failed 01=:',
  TheFoundPleaseSelectScheme: 'The scheme is not found, please select another scheme',
  AreYouWantToDelete: 'Are you sure you want to delete?',
  Tip: 'Tip',
  DeleteSchemeFailed: 'Delete scheme failed:',
  N1Exceeds4MBCannotUploaded: '1 file size exceeds 4MB, cannot be uploaded.',
  N1Exceeds20MBCannotUploaded: '1 file size exceeds 20MB, cannot be uploaded.',
  DeleteFileFailed: 'Delete file failed!',
  Edit: 'Edit',
  SelectFile: 'Select file',
  DeleteFile: 'Delete file',
  Upload: 'Upload',
  UploadFile: 'Upload file',
  FileName: 'File name',
  FileType: 'File type',
  FileSize: 'File size',
  Uploader: 'Uploader',
  UploadTime: 'Upload time',
  UploadProgress: 'Upload progress',
  Uploading2: 'Uploading...',
  WaitingForUpload: 'Waiting for upload',
  DocumentCategory: 'Document category',
  PlatformCustomerService: 'Platform customer service',
  Yes: 'Yes',
  No: 'No',
  Confirm: 'Confirm',
  SaveColumnStatus: 'Save column status',
  ResetColumnStatus: 'Reset column status',
  SaveColumnStatusSuccess: 'Save column status success',
  SaveColumnStatusFailed: 'Save column status failed',
  ResetColumnStatusSuccess: 'Reset column status success',
  ChatWindow: 'Chat window',
  Internal: 'Domestic',
  Communication: 'Communication',
  InternalCommunication: 'Internal Communication',
  ExternalCommunication: 'External Communication',
  Customer: 'Customer',
  Reset: 'Reset',
  Search: 'Search',
  CurrentlySelectedItem: 'Currently selected item:',
  Port: 'Port',
  State: 'State',
  FileAbnormalCannotBeUploaded: 'File volume is abnormal, cannot be uploaded.',
  File20MCannotBeUploaded: 'File size exceeds 20M, cannot be uploaded.',
  UploadSuccessful: 'Upload successful',
  ImportFile: 'Import file',
  PrintTemplate: 'Print template:',
  Code: 'Code',
  ChineseName: 'Chinese Name',
  EnglishName: 'English Name',
  Country: 'Country',
  Region: 'Region',
  Name2: 'Name',
  StartDate: 'Start Date',
  To: 'To',
  EndDate: 'End Date',
  CurrentAuthorizations: 'Current authorizations',
  Refresh: 'Refresh',
  User: 'User:',
  Authorization: 'Authorization',
  Time: 'Time:',
  AuthorizationUseHistory: 'Authorization use history:',
  AuthorizationFailed: 'Authorization failed',
  SendTest: 'Send test',
  CurrentPersonalAuthorizationList: 'Current personal authorization list',
  SendTo: 'Send to:',
  Confirm2: 'Confirm',
  Cancel: 'Cancel',
  Close: 'Close',
  Open: 'Open',
  AuthorizationItemDescription: 'Authorization item description',
  AuthorizationItem: 'Authorization item',
  AuthorizationStatus: 'Authorization status',
  NotSet: 'Not set',
  StatusChangeTime: 'Status change time',
  Operation: 'Operation',
  PleaseAddProductDescriptionHere: 'Please add product description here',
  WeChatMessagePush: 'WeChat message push',
  MarqueeSwitch: 'Marquee switch',
  PleaseInEmailPasswordauthorizationCode: 'Please fill in email password/authorization code!',
  PleaseFillInRecipientEmail: 'Please fill in recipient email!',
  EmailSettingsTestEmail: 'Email settings - test email',
  SendSuccessfully: 'Send successfully',
  PaymentUponReceipt: 'Payment upon receipt',
  All: 'All',
  Unread: 'Unread',
  Read: 'Read',
  MMDDDayHHMm: 'MMMM Do HH:mm',
  AssignSales: 'Assign sales',
  ReleaseSales: 'Release sales',
  ReviewSales: 'Review sales',
  SuccessfullyGrabCustomer: 'Successfully grab customer',
  GrabCustomerFailed: 'Grab customer failed',
  ScheduleReminder: 'Schedule reminder',
  CustomerExpirationReminder: 'Customer expiration reminder',
  BusinessReviewReminder: 'Business review reminder',
  CustomsDeclarationReminder: 'Customs declaration reminder',
  AbnormalHandlingOfBox: 'Abnormal handling of box',
  DeparturePickUpContainerWarning: 'Departure to pick up container warning',
  BoxArrivingAtFactoryWarning: 'Box arriving at factory warning',
  BoxLeavingFactoryWarning: 'Box leaving factory warning',
  CustomsReleaseWarning: 'Customs release warning',
  TerminalReleaseWarning: 'Terminal release warning',
  BoardingWarning: 'Boarding warning',
  DepartureWarning: 'Departure warning',
  ArrivalWarning: 'Arrival warning',
  ReturningBoxWarning: 'Returning box warning',
  SystemArrearsReminder: 'System arrears reminder',
  ChangeReviewAndApprovalReminder: 'Change fee review and approval reminder',
  DefaultMessage: 'Default message',
  Message: 'System message',
  SelectTemplate: 'Select template',
  PleaseSelectTheExportTemplate: 'Please select the export template',
  Upload0UploadFailure0: 'Upload success: {0}, Upload failure: {1}.',
  SuccessfulFailure0ConfirmSave: 'Successful upload: {0}, failure: {1}, confirm to save?',
  Only0FormatCanUploaded: 'Only files with {0} format can be uploaded',
  YouToOpenTheModule: 'You don\'t have permission to open the {0} module',
  Upload0UploadFailed0: 'Upload successful: {0}, Upload failed: {1}.',
  All2: '(All)',
  NumberOfPiecescommissionactual: 'Number of pieces (commission/actual)',
  LetterOfCreditTerms: 'Letter of Credit Terms',
  N4InsuranceCompletion: '4. Insurance completion',
  N2Inquiry: '2 Inquiry',
  SensitiveWords: 'Sensitive words',
  FreightRateDetails: 'Freight rate details',
  Manufacturer: 'manufacturer',
  ShipName: 'Ship name:',
  IsItCorrect: 'Is it correct.',
  BoxReturnedFromTheArea: 'Box cargo information returned from the port area:',
  CurrentlyStatusAndCannotDeleted: 'Currently in editing status and cannot be deleted',
  ChineseAbbreviationOfTheCompany: 'Chinese abbreviation of the company:',
  TheTheCompanyCannotEmpty: 'The English abbreviation of the company cannot be empty',
  Voyage: 'Voyage:',
  ShippingSchedule: 'Shipping schedule:',
  PortOfDepartureUpdate: 'Port of departure update',
  DestinationPortUpdate: 'Destination Port Update',
  ChatInside: 'Chat Inside',
  ChatByClient: 'Chat By Client',
  DoubleClickToSelectState: 'Double click to select state query',
  StateQuery: 'State query',
  EdiStateQuery: 'EDI state query',
  BookingEdiSendType: 'Booking EDI type',
  BookingEdiSendTime: 'Booking EDI time',
  imConnecting: 'Trying to connect.....',
  imConnectFailed: 'Session connection failed. Please close and reopen.',
  SwitchBranchAndOpenModuleTipAllEdit: 'Please save the data and close the opened modules before switching branches. Currently, {0} modules are open. Do you want to close all modules?',
  SwitchBranchAndOpenModuleTipNotEdit: 'Please close the modules that have already been opened before switching branches. Currently, {0} modules are open. Do you want to close all of them?',
  SwitchBranchAndOpenModuleTipPartEdit: 'Please save data and close modules before switching branches. Currently, {0} open modules have not been saved or closed. Do you want to close all of them?',
  PrintRecordsOverLimitTip: 'The number of printed records exceeds the system limit. Do you want to export them directly?',
  PrintRecordsOver100Tip: 'If the number of printed records exceeds 100, the loading time may be longer. Would you like to export it directly?',
  ContinuePreview: 'Continue preview',
  NotSupported: 'Currently does not support {0} multi journey data splicing display',
  PleaseFillInCorrectly: 'Please fill in the multi journey information correctly and do not allow any gaps in the middle',
  DoNotEmpty: 'One journey data cannot be cleared',
  AirlineReplacement: 'The airline has undergone a change and will clear the information of the departure port airport (airport, actual arrival time, actual loading time, estimated departure time, actual departure time) and retrieve the data again',
  AirlineReplacement1: '1. If the modified airline is not in the list of airlines that support subscription, data cannot be obtained',
  AirlineReplacement2: '2. There has been a change in the airline, and the departure port airport information (airport, actual arrival time, actual loading time, estimated departure time, actual departure time) will be cleared',
  AirlineReplacementLast: 'The last airline has undergone a change and will clear the destination airport information (estimated arrival time, actual arrival time, actual receipt time, actual unloading time, actual arrival notification time, actual pick-up time) and retrieve the data again',
  AirlineReplacementLast2: '2. There has been a change in the airline for the final leg, and the destination airport information (estimated arrival time, actual arrival time, actual receipt time, actual unloading time, actual arrival notification time, actual pickup time) will be cleared',
  ViewShippingTracking: 'If there are multiple routes with different airlines, please refer to the 【Shipping Tracking】 tab for data',
  IntermediateAirline: 'The modified airline is not in the list of supported subscription airlines and will not be able to obtain second leg data',
  ExportingPleaseWait: 'Exporting file, please wait',
  PrintTaskProcessing: 'Generating print files...',
  PrintTaskProcessingProgress: 'Generating print files ({0}/{1})...',
  PrintTaskDownloading: 'Generated. Downloading the file...',
  PrintTaskUnknownUnit: 'Print unit',
  PrintTaskFailed: 'Print task failed: {0}',
  ExportTakePlaceInBackground: 'You can leave the page and export will take place in the background',
  CompletionDownloadMessageReminderInRightCorner: 'After completion, please download it from the "Message Reminder" {0} in the upper right corner.',
  FileExportCompletionReminder: 'File export completion reminder',
  SyncPartnerToFinanceCodeReminder: 'Reminder of customer/supplier code import completion',
  NoNewPermissionsForFees: 'There are no new permissions for fees',
  NoPayChargesImport: 'You don\'t have the Payable Charges New privilege and you can\'t import expenses',
  NoCostChargesImport: 'You don\'t have the Chargeable New privilege and no fees to import',
  OnlyCostChargesImport: 'You do not have the Add Payable Fees permission, only import the Payable Fees',
  OnlyPayChargesImport: 'You don\'t have the Add Fees due permission, only import the Payable Charges',
  ConfirmDeleteN: 'Are you sure to delete this {0} record?',
  AffiliatedBranchStyle: 'Style of affiliated branch',
  DisplayByOrganizationalStructure: 'Display by organizational structure',
  AllDisplay: 'All display',
  FileView: 'File View',
  NotPermissionToEditFilesByOtherUsers: 'Insufficient permissions: Do not have permission to edit files uploaded by other users',
  NotMatchingTheCostOfTheProjectCanBeDelete: 'There are no matching expense items to delete.',
  ThisPartnerDoesNotSupportEnterReceivableFees: 'This Partner Does Not Support Enter Receivable Fees',
  ThisPartnerDoesNotSupportEnterPayableFees: 'This Partner Does Not Support Enter Payable Fees',
  Can_Changed: 'Can be changed',
  Customer_Service: 'Customs Service Department',
  Documentation_Department: 'Document Department',
  Countries_Regions_Destination: 'Countries and regions of the destination port',
  CargoDocAndContainerQWTNotSame: 'The packing information of the bill of lading is inconsistent with the business packing information!',
  Some_Items_Have_Expired: 'Some of the fee items have expired and the transcription has failed',
  SentDestinationPortAgentTip: 'Notification has been sent to the destination port agent file',
  SendFileVerification: 'Send file verification',
  SendFileVerificationSuccessTip: "The file verification was successful. Please click 'Next' to continue sending the email, or 'Cancel'",
  Validating: 'Validating',
  MasterCheckExist: 'Main ticket verification: {0} exists',
  SmallCheckExist: 'Small ticket verification: {0} exists',
  EmailAttachments: 'Email attachments',
  DeleteAttachTip: 'Are you sure you want to delete this attachment?',
  LocalEmailSentSuccess: 'Successfully sent via local email?',
  LocalEmailTooLarge: 'The email content is too large to redirect to the local mailbox!',
  Lack: 'Lack',
  FileDragArea: 'Drag and drop files to this area to upload',
  EnterKeyword: 'Enter Keyword',
  ClearSelectedItems: 'Clear selected items',
  ManifestFileNumBox: 'The number of MANIFEST files is equal to the number of boxes',
  ManifestFileNumNotEqualBox: '[Box Quantity]: {0}/[MAINFIEST] Number of Files: {1}, MANIFEST Files and Box Quantity Inconsistent',
  TheSelectedDataIsIgnoredSuccessfully: 'The selected data is ignored successfully',
  SelectedDataHasBeenBatchProcessedSuccessfully: 'Successfully cancel ignore selected data. Procedure',
  ThereAreNoNegligibleCosts: 'There are no negligible costs',
  ThereAreNoFeesThatCanBeEliminated: 'There are no fees that can be eliminated',
  OnlyUnRead: 'Just watch, not read',
  AllMarksRead: 'All marks read',
  MessageConfig: 'Message setting',
  SaleProductCodeCannotBeNull: 'Allow Sale Product cannot be null',
  FullOrInsideCannotBeNull: 'Full Or Inside cannot be null',
  NotNullForMapping: 'The basic tab fields "【 Allow Sale Product 】 and 【 Full Or Inside 】 can not be empty". Please enter and then select the cost',
  DifferentJobOrBusinessFieldValues: 'The selected service contains multiple different jobs or service field values. If this parameter is not set, the original job and field values are retained',
  PreserveOriginalValue: 'Preserve original value',
  SelectSynchronizedFields: 'Select synchronized fields',
  SynchronizedFields: 'Synchronized fields',
  RunSuccess: 'Running successfully',
  RunFail: 'Running failed',
  PleaseUpload: 'The original value is empty, please upload the file',
  CodeTip: '1、The code language here：javascript' +
      '\n2、The default original object name to be processed is：result. (The entire content of result is the JSON object of the original value)' +
      '\n3、To obtain the first element, you can use： result[0]. (Count elements from the 0th one)' +
      '\n4、To obtain the value of a certain recognition field, you can use：result[0].text.data[\'package\']' +
      '\n5、To modify the value of the packaging, you can use：result[0].text.data[\'package\'] =\'PPK\'' +
      '\n6、To replace all the values of "P" in the packaging, you can use：result[0].text.data[\'package\'] =result[0].text.data[\'package\'].replaceAll(\'P\',\'B\');',
  NoVirtualHBLTip: 'This service does not have a formal order. Select the formal order before performing the operation',
  BlIsIssued: 'The bill of lading has been issued',
  NoVirtualHBLAuthTip: 'Do not have the permission of this TAB, please contact the administrator to configure the form of suborder permission to use!',
  FieldValueCannotBeNull: '{0} can\'t be empty',
  ImportFailedFileNameNotMatch: 'Import failed, file name does not start with ISF5 or ISF10',
  ISF5File: 'ISF5 Template',
  ISF10File: 'ISF10 Template',
  BookingLabel: 'Booking label',
  BatchPurchasePriceLock: 'Please select the business with unlocked purchase price for operation.',
  BatchPurchasePriceUnLock: 'Please select the business with locked purchase price for operation.',
  BatchSellingPriceUnLock: 'Please select the business with locked selling price for operation.',
  BatchSellingPriceLock: 'Please select the business with unlocked selling price for operation.',
  NotPermissionToViewFiles: 'There is a file {0}, that cannot be viewed without permission, and emails cannot be sent to it',
  ContainerTotalNeedEqual: 'The total number of containers including outer packaging, inner packaging, gross weight, and net weight must match the total number in the special cargo number',
  PackingAddNotRepeat: 'The selected packing information has been added, please do not add it again',
  vesselNotFound: 'Ship name cannot be directly entered, please check and re-enter!',
  exportToImportNotUpdatedVessel: 'For export to import, the vessel name cannot be modified in the Booking tab',
  voyageNotFound: 'The voyage number cannot be directly entered. Please check and re-enter!',
  exportToImportNotUpdatedVoyage: 'For export to import, the voyage cannot be modified in the Booking tab',
  smallReceiptNotVoyage: 'Sub-vouchers under the master bill cannot edit the flight',
  mblOnlyNotFreightTermHBL: 'If not a direct bill, the freight terms of the HBL cannot be modified',
  notUpdateFreightTermHbl: 'For export to import transactions, HBL freight terms cannot be updated',
  otherButtonNotUpdate: 'If other buttons are not selected, modification is not allowed',
  notUpdateDischargingPortDoor: 'If discharging port services are not selected, discharging port dispatch cannot be selected',
  notUpdateDispatchingPlaceCode: 'This document is the master bill and does not have the dispatch location (code) field for modification',
  notUpdatePacking: 'For export to import transactions, the packing field cannot be updated',
  notUpdateDispatchingPlaceExport: 'For export to import transactions, the dispatch location field cannot be updated',
  notUpdateDispatchingPlace: 'This document is the master bill and does not have the bill of lading dispatch location field for modification',
  notUpdateOther: 'This document is the master bill and does not have other sections for modification',
  notUpdateCustomsDeclarationType: 'Customs declaration not selected, customs declaration type field cannot be modified!',
  haveChargeNotUpdateCustomsDeclarationType: 'Existing charges prevent modification of customs declaration type field!',
  packingRequired: 'Packing field is required and cannot be empty!',
  freightTermHBLRequired: 'HBL freight terms field is required and cannot be empty!',
  seBookingTermRequired: 'Booking terms field is required and cannot be empty!',
  aeBookingTermRequired: 'Booking type is a required field and cannot be empty!',
  noUpdateCustomClaim2: 'Customs declaration method is not entrusted, cannot modify declaration type!',
  transportLineRequired: 'Shipping route is a required field and cannot be empty!',
  noUpdateSmallTicketTransportLine: 'Cannot modify shipping route for small tickets with a master bill!',
  departureStationRequired: 'Departure station is a required field and cannot be empty!',
  noUpdateSmallTicketDepartureStation: 'Cannot modify departure station for small tickets with a master bill!',
  destinationStationRequired: 'Destination station is a required field and cannot be empty!',
  noUpdateSmallTicketDestinationStation: 'Cannot modify destination station for small tickets with a master bill!',
  noUpdateSmallTicketForwardingAgent: 'Cannot modify forwarding agent for small tickets with a master bill!',
  businessLock: 'Business is locked and cannot be modified',
  businessNotEmpty: 'Bill of Lading number cannot be empty',
  businessNotUpdate: 'Bill of Lading does not meet modification conditions',
  notOperateNotUpdateQuantity: 'No permission to edit bill quantity',
  notOperateNotUpdateWeight: 'No permission to edit gross weight',
  notOperateNotUpdateCubage: 'No permission to edit volume',
  notOperateNotUpdatePackingName: 'No permission to edit package display name',
  notOperateNotUpdatePaymentPlaceBL: 'Cannot edit HBL payment location field',
  notOperateNotUpdateRequestReleaseState: 'Cannot edit bill release request status field',
  notOperateNotUpdateFreightTermHBL: 'Cannot edit transport terms field',
  notOperateNotUpdateSoNo: 'Cannot edit SO NO. field',
  notOperateNotUpdateLoadingPortCode: 'Cannot edit loading port field',
  notOperateNotUpdateDischargingPortCode: 'Cannot edit discharging port field',
  notOperateNotUpdateVesselVoyage: 'Cannot edit vessel/voyage field',
  notOperateNotUpdateDestinationPortCode: 'Cannot edit destination port field',
  notOperateNotUpdateReleaseDate: 'Cannot edit release date field',
  notOperateNotUpdateWithHoldDate: 'Cannot edit hold date field',
  notOperateNotUpdateSurrenderedNo: 'Cannot edit release number field',
  notOperateNotUpdateWithHoldReason: 'Cannot edit hold reason field',
  selectRequirement: 'Double-click to select operation requirement',
  DataGroup: 'Data Group',
  CloseRefreshNeedMannulUpdate: 'When turning off automatic refresh, you need to manually click [Refresh] to update the data!',
  RefreshRule: 'Refresh rule:',
  NodeRecord: 'Node record:',
  HomePageNotRefreshData: 'Do not automatically refresh data when entering the homepage',
  DisplayLastClickNode: 'Display the last clicked node',
  RetainQueryCondition: 'And retain the query conditions of the node',
  N0VerificationPassed: '[{0}] Verification passed',
  ConsigneeCompanyName: 'Consignee Company Name',
  TaskBoard: 'Task Board:',
  AlertNode: 'Warning Node:',
  DoOfQueryResultsTemplates: 'Do not display based on the number of query results, reset query conditions when switching templates',
  SendPortAgentByNumber: 'Send to destination port agent - by container number',
  SendAgentByCaseNumber: 'Send set list agent - by case number',
  SetOrderAgency: 'Set Order Agency',
  LastSentTime: 'Last Sent Time',
  BusinessOperationsCannotBeModified: 'There are cargo spaces associated with business statuses "Verified", "Committed", "Pre-Commit", or "Committing". They cannot be modified via bulk ship transfer. Each must be edited individually.',
  UpdateVoyageInfoMessage: 'Update voyage information, which will also update related voyage details in ocean export operations. A confirmation email will be sent after submission:',
  updateBatchTips: 'Updating voyage information will simultaneously update related details in海运export operations. Confirm?',
  batchUpdateShipSuccess: 'Batch ship transfer succeeded',
  ShippingCompanyCannotBeModifiedBylclMasterUuid: 'If the LCL master bill is not empty, the shipping company cannot be modified.',
  ShippingCompanyCannotBeModifiedByCharge: 'If the shipping company has associated fees, modifications are not allowed.',
  ShippingCompanyNotExist: 'Ship company does not exist',
  AirCompanyCannotBeModifiedBylclMasterUuid: 'If the LCL master bill is not empty, the airline cannot be modified.',
  AirCompanyCannotBeModifiedByCharge: 'If the airline has associated fees, modifications are not allowed.',
  AirCompanyNotExist: 'Airline does not exist',
  SeToSiCannotBeUpdatedToShippingCompany: 'Cross-tenant export-to-import business does not allow modification of the shipping company',
  TheDesignatedFreightForwarderCannotBeModified: 'The designated freight forwarder cannot be modified',
  TheValueOfTheDesignatedFreightForwarderIsIncorrect: 'The value of the designated freight forwarder is incorrect',
  CustomPageSettings: 'Custom Page Settings',
  EnterCustomPageSettings: 'Enter custom page settings',
  Russian: 'Russian',
  Vietnamese: 'Vietnamese',
  Thai: 'Thai',
  SelectTransshipmentStatusErrorPrompt: 'Only supports batch modification of positive operation business.',
  PleaseSelectTheMainTicketForModification: 'Please select the main ticket for modification',
  NoAccessPermission: 'No access permission'
}
